import React, { useEffect, useState } from "react";
import Lang from "../../../lang";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import $ from "jquery";
import "@patternfly/react-core/dist/styles/base.css";
import Select from 'react-select'
import FiscalizacaoGrid, {changeColumnsFiscalizacaoGrid,changeValueSelect} from './Grid1/ClassGrid';
import FiscalizacaoGrid2, {changeValueSelect2} from './Grid2/ClassGrid2';
import FiscalizacaoGrid3, {changeValueSelect3} from './Grid3/ClassGrid3';
import FiscalizacaoGrid4, {changeValueSelect4} from './Grid4/ClassGrid4';
import FiscalizacaoGrid5 , {changeValueSelect5} from './Grid5/ClassGrid5';
import FiscalizacaoGrid6 , {changeValueSelect6} from './Grid6/ClassGrid6';
import FiscalizacaoGrid7 , {changeValueSelect7} from './Grid7/ClassGrid7';
import FiscalizacaoGrid8 , {changeValueSelect8} from './Grid8/ClassGrid8';
import FiscalizacaoGrid9 , {changeValueSelect9} from './Grid9/ClassGrid9';
import FiscalizacaoGrid10 , {changeValueSelect10} from './Grid10/ClassGrid10';
import FiscalizacaoGrid11 , {changeValueSelect11} from './Grid11/ClassGrid11';
import FiscalizacaoGrid12 , {changeValueSelect12} from './Grid12/ClassGrid12';
import FiscalizacaoGrid13 , {changeValueSelect13} from './Grid13/ClassGrid13';
import { NumericCell } from './NumericText';
import NumericCellDinamic from './NumericTextDinamic';
import { NumericCellNrInicialFinal } from "./NumeroInicialFinal";
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import { Input, Switch } from "@progress/kendo-react-inputs";
import LocationFunction from '../../../components/common/LocationFunction.jsx';
import FormleftNev from "../../../components/common/FormleftNev";
import DropDownCellTipoVasilha from './myDropDownCellTipoVasilha';
import DropDownCellNVasilha from './myDropDownCellNVasilha';
import DropDownCellTipoSelo from './myDropDownCellTipoSelo'
import DropDownCellCapacidades from './myDropDownCellCapacidades';
import DropDownCellCor from "./myDropDownCellCor";
import DropDownCellProduto from './myDropDownCellProduto';
import DropDownCellRegisto from './myDropDownCellRegisto';
import DropDownCellRegistoDevolucoes from "./myDropDownCellRegistoDevolucoes";
import DropDownCellCorrelativa from './myDropDownCellCorrelativa';
import DropDownCellCorrelativaProduto from "./myDropDownCellCorrelativaProduto";
import DropDownCellRotulo from "./myDropDownRotulo";
import DropDownAutoOrigem from "./myDropDownAutoOrigem";
import DropDownCellAllProdutoGridsEngarrafado from "./myDropDownCellAllProdutoGridsEngarrafado"
import DropDownCellAllProdutoGridsGranel from "./myDropDownCellAllProdutoGridsGranel";
import DropDownCellAllProdutoGridsVendas from "./myDropDownCellAllProdutoGridsVendas";
import {CheckboxGrid} from "./CheckboxGrid"
import DropDownCellAllEntidadesInstVinicaVendas from "./myDropDownCellAllEntidadesInstVinicaVendas"
import DropDownCellAllEntidadesInstVinicaGranel from "./myDropDownCellAllEntidadesInstVinicaGranel"
import DropDownCellAllEntidadesInstVinicaEngarrafado from "./myDropDownCellAllEntidadesInstVinicaEngarrafado"
import DropDownCellAllProdutoGridsEngarrafadoSelagem from "./myDropDownCellAllProdutoGridsEngarrafadoSelagem";
import DropDownCellDocumentos from "./myDropDownCellDocumentos"
import DropDownCellSeriesSelo from './myDropDownCellSeriesSelo'
import DropDownCellIntervalosSelos from './myDropDownCellIntervalosSelo'
import DropDownCellAllProdutoGridsSemContas from './myDropDownCellAllProdutoGridsSemContas'
import DropDownCellCorrelativaFDO from "./myDropDownCellCorrelativaFDO";
import DropDownCellRegistoFDO from "./myDropDownCellRegistoFDO";
import DropDownCellAllProdutoAdicionar from "./myDropDownCellAllProdutoAdicionar";
import DropDownCellCapacidadesFDO from "./myDropDownCellCapacidadesFDO";
import {FormatMoney} from './FormatMoney';
import DropDownCellAllProdutoObter from "./myDropDownCellAllProdutoObter";
import SelectCellEtiquetas from './mySelectCellEtiquetas';
import SelectCellSelos from './mySelectCellSelos';
import SelectCellSelosGarantia from "./mySelectCellSelosGarantia";
import InputCell from './myInputCell';
import InputCellNLote from './myInputCellNLote';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import DropDownCellProduto2 from "./Grid2/myDropDownCellProduto2";
import InserirFiscalizacao from "./InserirFiscalizacao";
import {InputFieldsAll, InputFieldsAllParecer} from "./InserirFiscalizacao";
import queryString from "query-string";
import services from "../../../services";
import DropDownCellAllProduto from "./myDropDownCellAllProduto";
import SelectCellSelosSelagem from "./mySelectCellSelosSelagem"
import SelectCellEtiquetasSelagem from "./mySelectCellEtiquetasSelagem"
import ButtonCell from "./myButtonCell"
import { getItems } from "./Grid1/services";
import ClassGrid from "./Grid1/ClassGrid";
const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MM/yyyy";
var thisCreateGrid = this;
var ArrayDataFields = [];
var ColumnsGrid = [];
var ColumnsGridAEngarrafado = []
var ColumnsGridViatura = []
var ColumnsGridSelosGarantia = []
var ColumnsGridRotulos = []
var  ColumnsGridRotulosOutroAuto = []
var ColumnsGridSelosOutroAuto = []

var ColumnsGridEngarrafadoVistoria = []
var ColumnsGridGranelVistoria = []
var ColumnsGridSelosVistoria = []
// var ColumnsGridCapsulasVistoria = []
var ColumnsGridVendasVistoria = []
var ShowColumnProdutosSemConta = false;

var options = []
var typeAutoValue = "";

var granelcheck =  false;
var engarrafadocheck =  false;
var viaturacheck =  false;
var selosGarantiacheck = false;
var rotuloscheck = false;
var idAutoOrigem;
var rotulosOutroAutocheck = false
var selosOutroAutocheck = false
var queryParams = queryString.parse(window.location.search)
var token = +queryParams.idAuto
var estadoQuery = +queryParams.codEstado
var leftNavFields;
class FiscalizacaoClassCreateGrid extends React.Component {
 
  constructor(props) {
    super(props);
    this.state = {
        isCheckboxChecked: false,
        columnsGrid : [],
        ColumnsGridAEngarrafado:[],
        ColumnsGridViatura: [],
        ColumnsGridSelosGarantia: [],
        ColumnsGridRotulosOutroAuto : [],
        ColumnsGridSelosOutroAuto : [],
        ColumnsGridRotulos: [],
        ShowColumnProdutosSemConta: false,
        ColumnsGridEngarrafadoVistoria: [],
        ColumnsGridGranelVistoria: [],
        ColumnsGridSelosVistoria: [],
        // ColumnsGridCapsulasVistoria: [],
        ColumnsGridVendasVistoria: [],

        certProcIVDest: [],
        finalDataArray: [],
        show: false,
        isRemarkSet: false,
        mandatoryMissing: false,
        headName: " Gestão de Autos",
        sendData: {
            processomento: {
                pmentos: [],
            },
            processo: {
                bib: false,
                seloIncorporado: false,
                logo: false,
                macrapropria: false,
            },
            Dataatual: new Date(),
            Ultimaobservacao: "",
            aprovodo: true,
        },
        // readOnly : false,
        readOnly: true,
        parsed: {},
        telkikTable: "",
        entityGrid: "",
        tituloList: [],
        processoTelkikTable: "",
        resData: {},
        registoData: {},
        filterData: [
            {
                "Nº Registo": "a",
                Produto: "a",
                Cor: "a",
                Álcool: "a",
                Tipo: "a",
                Ano: "a",
                Doçura: "a",
                "Acidez (%)": "a",
                "Saldo Incial (Lts)": "a",
                Madeira: "a",
                "Velor energetico": "Velor energetico",
                Carbohydratos: "Carbohydratos",
                Proteinas: "Proteinas",
                "Fibra Elimentor": "Fibra Elimentor",
                Sodio: "Sodio",
                "Rotulus aprovados": "xxxxx",
            },
        ],
        nullProcess: true,
    };
  }

  handleCheckboxChange = e => {
    var isCheckboxChecked = e.target.checked;
    this.setState({ isCheckboxChecked});
    FiscalizacaoClassCreateGrid.changeColumnsGrid($("#tipo_auto :selected").val());
  }

  handleChangeNIFAgente = e => {
   
    (async () => {
      var NIFAgente = e.target.value;
      const data = {nif: NIFAgente}
      const GetAgenteDados = await services.apiCall.requestApi(
        "/Fiscalizacao/GetAgentByNIF",
          data,
          "get"
      );
      
        if(GetAgenteDados){
         console.log(GetAgenteDados)
         $("#NomeDesignacaoAE").val(GetAgenteDados.nome)
        }
      
    })()
    
  }

  static componentDidMount = (DetalhesAuto) => {

    if(DetalhesAuto != undefined){
      idAutoOrigem = DetalhesAuto.idAutoOrigem
    }

    (async () => {
      const data = {idEntidade : $("#instal_vinica_auto :selected").val().split("!")[1]}
      const AutoOrigemList = await services.apiCall.requestApi(
        "/Fiscalizacao/GetAutoOrigens",
          data,
          "get"
      );
      
        if(AutoOrigemList){
          for (let index = 0; index < AutoOrigemList.length; index++) {
            var idAuto = AutoOrigemList[index].idAuto;
            var numeroAuto = AutoOrigemList[index].numeroAuto;
          options.push({value:idAuto, label: numeroAuto })
        }
      }
      
    })()

  }
  maxLengthCheck(object)
  {
    if (object.value.length > object.maxLength)
      object.value = object.value.slice(0, object.maxLength)
  }

  CapacidadeCell = (props) => {
    
    // return <td id="id-Correlativa-Capacidade"></td>;
    return <td role={"gridcell"} id="id-Correlativa-Capacidade" className="k-grid-edit-cell"></td>;

  };

  componentDidUpdate() {
    
    $('#id-requisitos-fiscalizacao [type="checkbox"]').on('change', function(e){

      var value = e.target.checked;
      $(this).closest('.switch-h-f').find('[type="checkbox"]').prop( "checked", false );
      $(this).prop( "checked", value );

    })

    if($(".ant-select-selection-item").text() != '' && $("#instal_vinica_auto :selected").val() != ''){
      InserirFiscalizacao.changeValueButton(true)
    }
    if(options.length == 0){
      (async () => {
        const data = {idEntidade : $("#instal_vinica_auto :selected").val().split("!")[1]}
        const AutoOrigemList = await services.apiCall.requestApi(
          "/Fiscalizacao/GetAutoOrigens",
            data,
            "get"
        );
        
          if(AutoOrigemList){
            for (let index = 0; index < AutoOrigemList.length; index++) {
              var idAuto = AutoOrigemList[index].idAuto;
              var numeroAuto = AutoOrigemList[index].numeroAuto;
            options.push({value:idAuto, label: numeroAuto })
          }
        }
        
      })()
    }
   
    if($("#tipo_auto :selected").val() == "5"){
      if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var token = +queryParams.idAuto
        // $("#id-DropDownAutoOrigem option[value='" + token + "']").attr("selected","selected");
        FiscalizacaoGrid7.ClassGrid7.getFilter(idAutoOrigem)
        
      }
    }
  
  }

  handleProdutoChange = (value) => {
    // Atualiza o estado de ShowColumnProdutosSemConta baseado no valor do dropdown
    this.setState({ ShowColumnProdutosSemConta: true });
};
  static changeColumnsGrid = (typeAuto) =>{
    typeAutoValue = typeAuto;

    if(typeAuto == "1"){

      {ColumnsGrid = [
        <Column key={1} field="Tipo_Vasilha" title="Tipo Vasilha" cell={DropDownCellTipoVasilha} width="200%"/>,
        <Column key={2} field="N_Vasilha" title="Nº Vasilha" cell={DropDownCellNVasilha} width="90%"/>,
        <Column key={3} field="Capacidade_aferida" title="Cálculos Vasilha" cell={ButtonCell}  width="100%"/>,
        <Column key={4} field="Quantidade_aferida" title="Capacidade Aferida (L)" cell={NumericCell} width="120%"/>,
        <Column key={5} field="Falta" title="Falta (m)" cell={NumericCell} width="90%"/>,
        <Column key={6} field="QuantidadeApurada" title="Quantidade Apurada (L)" cell={NumericCell} width="120%"/>,
        // <Column key={7} field="Produto_NC_GA_IG" title="Produto" cell={DropDownCellProduto} width="400%"/>,
        <Column key={7} field="TipoProduto" title="Produto"   cell={(props) => <DropDownCellAllProdutoGridsEngarrafado {...props} tipoProduto="colheita"/>}  width="400%" />,
        <Column key={8} field="ProdutosSemConta" title="Produto sem conta" cell={DropDownCellAllProdutoGridsSemContas}  width="400%" />,
        <Column key={9} field="Ano" title="Ano" cell={NumericCell} width="120%"/>,
        <Column key={10} field="Cor" title="Cor" cell={DropDownCellCor} width="120%"/>,

        <Column key={11} title="IVDP" headerClassName="gridStyleTitle">
          <Column key={12} field="N_Garrafas_IVDP" title="Nº Garrafas" cell={NumericCell} width="120%"/>
          <Column key={13} field="Capacidade_IVDP" title="Capacidade" cell={DropDownCellCapacidades} width="100%"/>
          <Column key={14} field="Etiquetas_segurança_IDVP" title="Etiquetas de segurança" cell={SelectCellEtiquetas} width="150%"/>
        </Column>,
        <Column key={15} title="AE" headerClassName="gridStyleTitle">
          <Column key={16} field="N_Garrafas_AE" title="Nº Garrafas" cell={NumericCell} width="120%"/>
          <Column key={17} field="Capacidade_AE" title="Capacidade" cell={DropDownCellCapacidades} width="100%"/>
          <Column key={18} field="Etiquetas_segurança_AE" title="Etiquetas de segurança" cell={SelectCellEtiquetas} width="150%"/>
          </Column>,
        <Column key={19} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="100%" />

        
      ]}
    }else if(typeAuto == "2"){

      {ColumnsGrid = [
        <Column key={1} field="RegistoProduto" title="Certificação/Produto (todos)" width="400%" cell={DropDownCellProduto}/>,
       // <Column key={2} field="Cor" title="Cor" width="123px"/>,
        <Column key={2} field="VolumeAferido" title="Volume aferido" cell={FormatMoney}  width="120%"/>,
        <Column key={3} field="SelosSeguranca" title="Selos de Segurança" cell={SelectCellSelos} width="150%"/>,
        <Column key={4} title="IVDP" headerClassName="gridStyleTitle"><Column key={5} field="NGarrafasIVDP" title="Nº Garrafas" cell={NumericCell} width="120%"/><Column key={6} field="Capacidade_IVDP" title="Capacidade" cell={DropDownCellCapacidades}  width="100%"/><Column key={7} field="EtiquetasSegurancaIVDP"  title="Etiquetas de segurança" cell={SelectCellEtiquetas} width="150%"/></Column>,
        <Column key={5} title="AE" headerClassName="gridStyleTitle"><Column key={8} field="NGarrafasAE" title="Nº Garrafas" cell={NumericCell} width="120%"/><Column key={9} field="Capacidade_AE" title="Capacidade" cell={DropDownCellCapacidades}  width="100%"/><Column key={10} field="EtiquetasSegurancaAE" title="Etiquetas de segurança" cell={SelectCellEtiquetas} width="150%"/></Column>,
        <Column key={6} cell={FiscalizacaoGrid.ClassGrid.CommandCell}  width="100%" />
      ]}

    }else if(typeAuto == "3"){

      {ColumnsGrid = [
        <Column key={1}  field="DocEntrada" title="Data de Entrada" cell={NumericCell} width="140%"/>,
        <Column key={2}  field="DocSaida" title="Data de Saída" cell={NumericCell} width="140%"/>,
        <Column key={3}  cell={DropDownCellRegistoDevolucoes} field="Registo" title="Nº de Certificação" width="120%"/>,
        <Column key={4}  cell={DropDownCellCorrelativa} field="Correlativa" title="Nº de Rotulagem" width="120%"/>,
        <Column key={5}  cell={InputCellNLote} field="NLote" title="Nº Lote" width="120%"/>,
        <Column key={6}  field="NGarrafasDevolvidas" title="Nº Garrafas Devolvidas" cell={NumericCell} width="120%"/>,
        <Column key={7}  field="Capacidade" title="Capacidade (lts)" className="CapacidadeCell" editable={false} width="120%"/>,
        <Column key={8}  field="QtdFinal" title="Qtd final (lts)" cell={NumericCell} width="120%"/>,
        <Column key={9}  cell={FiscalizacaoGrid.DropDownCellMotivoDispensa} field="MotivoDispensa" title="Motivo dispensa CA" width="200%"/>,
        <Column key={10}  field="NGarrafasAmostra" title="Nº Garrafas Amostra" cell={NumericCell} width="120%"/>,
        <Column key={11} field="Etiquetas_segurança_IDVP" title="Etiquetas de segurança" cell={SelectCellEtiquetas} width="150%"/>,
        <Column key={12} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
      ]}

    }else if(typeAuto == "4"){

      {ColumnsGrid = [
        <Column key={1} cell={DropDownCellRegistoFDO} field="Registo" title="Nº de Certificação" width="120%"/>,
        <Column key={2} cell={DropDownCellCorrelativaFDO} field="Correlativa" title="Nº de Rotulagem" width="160%"/>,
        <Column key={3} field="CapacidadeFDO" title="Capacidade" className="CapacidadeFDO" cell={DropDownCellCapacidadesFDO} width="120%" />,
        <Column key={4} cell={InputCellNLote} field="NLote" title="Nº Lote" width="120%"/>,

        <Column key={5} title="IVDP" headerClassName="gridStyleTitle">
          <Column key={6} field="NGarrafasIVDP" title="Nº Garrafas" cell={NumericCellDinamic} width="120%"/>
          <Column key={7} field="SelosGarantiaIVDP"  title="Selos de Garantia" id="selosGarantiaIVDP" cell={SelectCellSelosGarantia} width="120%"/>
          <Column key={8} field="EtiquetasSegurancaIVDP"  title="Etiquetas de segurança" cell={SelectCellEtiquetas} width="120%"/>
        </Column>,

        <Column key={9} title="AE" headerClassName="gridStyleTitle">
          <Column key={10} field="NGarrafasAE" title="Nº Garrafas" cell={NumericCellDinamic} width="120%"/>
          <Column key={11} field="SelosGarantiaAE"  title="Selos de Garantia" id="selosGarantiaAE" cell={SelectCellSelosGarantia} width="120%"/>
          <Column key={12} field="EtiquetasSegurancaAE" title="Etiquetas de segurança" cell={SelectCellEtiquetas} width="120%"/>
        </Column>,

        <Column key={13} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />

      ]}

    }else if( typeAuto == "5"){// Grid Detalhes - Engarrafado
      if($("#id-label-verified-solicited").is(":checked") == true){
        {ColumnsGrid = [
          // <Column key={1} field="RegistoProduto" title="Registo/Produto (todos)" width="400%" cell={DropDownCellRegisto}/>,
          // <Column key={2} field="Correlativa" title="Correlativa"  width="300%" cell={DropDownCellCorrelativa}/>,
          // <Column key={3} field="NLote" title="Nº Lote" width="90%"   cell={InputCellNLote}/>,
          // <Column key={4} field="NGarrafas" title="Nº Garrafas"   width="120%" cell={NumericCell}/>,
          // <Column key={5} field="Capacidade" title="Capacidade (lts)" cell={thisCreateGrid.CapacidadeCell} width="100%" />,
          // <Column key={5} field="TotalQBD"  title="Total"  width="90%" cell={InputCell} />,
          // <Column key={6} cell={FiscalizacaoGrid7.ClassGrid7.CommandCell} width="100%" />
  
          <Column key={1} field="RegistoProduto" title="Nº certificação" cell={DropDownCellRegisto} />,
          <Column key={2} field="CorrelativaND" title="Correlativa" className="CorrelativaND" cell={DropDownCellCorrelativa}/>,
          <Column key={3} field="NLote" title="Nº Lote" cell={InputCellNLote}/>,
          <Column key={4} field="NGarrafas" title="Nº Garrafas"  cell={NumericCell}/>,
          <Column key={5} field="CapacidadeND" title="Capacidade" className="CapacidadeND" cell={DropDownCellCapacidades} />,
          <Column key={6} field="TotalQBD"  title="Total" editable= {false} className="TotalQBDND"/>,
          <Column key={7} cell={FiscalizacaoGrid8.ClassGrid8.CommandCell} width="90px" />
        ]}
      }else{
        {ColumnsGrid = [
          // <Column key={1} field="RegistoProduto" title="Registo/Produto (todos)" width="400%" cell={DropDownCellRegisto}/>,
          // <Column key={2} field="Correlativa" title="Correlativa"  width="300%" cell={DropDownCellCorrelativa}/>,
          // <Column key={3} field="NLote" title="Nº Lote" width="90%"   cell={InputCellNLote}/>,
          // <Column key={4} field="NGarrafas" title="Nº Garrafas"   width="120%" cell={NumericCell}/>,
          // <Column key={5} field="Capacidade" title="Capacidade (lts)" cell={thisCreateGrid.CapacidadeCell} width="100%" />,
          // <Column key={5} field="TotalQBD"  title="Total"  width="90%" cell={InputCell} />,
          // <Column key={6} cell={FiscalizacaoGrid7.ClassGrid7.CommandCell} width="100%" />
  
          <Column key={1} field="RegistoProduto" title="Nº certificação" editable= {false} />,
          <Column key={2} field="Correlativa" title="Correlativa" className="CorrelativaND" editable= {false}/>,
          <Column key={3} field="NLote" title="Nº Lote" editable= {false}/>,
          <Column key={4} field="NGarrafas" title="Nº Garrafas"  cell={NumericCell}/>,
          <Column key={5} field="CapacidadeND" title="Capacidade" className="CapacidadeND" cell={DropDownCellCapacidades} />,
          <Column key={6} field="TotalQBD"  title="Total" editable= {false} className="TotalQBDND"/>,
          <Column key={7} cell={FiscalizacaoGrid7.ClassGrid7.CommandCell} width="90px" />
        ]}
      }
      
    }else if(typeAuto == "9"){
      {ColumnsGrid = [
        <Column key={1} field="tipo_rotulos" title="Tipo" cell={DropDownCellRotulo}/>,
        <Column key={2} cell={DropDownCellRegisto} field="Registo_rotulos" title="Nº de Certificação" />,
        <Column key={3} cell={DropDownCellCorrelativa} field="Correlativa_rotulos" title="Nº de Rotulagem"/>,
        <Column key={4} field="Descricao_rotulos" title="Descrição (livre)"  />,
        <Column key={5} field="Quantidade_rotulos" title="Quantidade" cell={NumericCell} />,

        <Column key={6} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
      ]}
    }else if(typeAuto == "10"){
      {ColumnsGrid = [
        <Column key={1} field="TipoRegisto" title="Tipo" cell={DropDownCellRotulo} />,
        <Column key={2} cell={DropDownCellRegisto} field="Registo" title="Nº de Certificação"/>,
        <Column key={3} cell={DropDownCellCorrelativa} field="Marca" title="Marca"/>,
        <Column key={4} field="Produto" title="Produto"  />,
        <Column key={5} field="Tipo" title="Tipo" cell={NumericCell} />,
        <Column key={6} field="NSelos" title="Nr Selos" cell={NumericCell} />,
        <Column key={7} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
      ]}
    }else if(typeAuto == "24"){
      {ColumnsGridEngarrafadoVistoria = [
        <Column key={1} field="EntidadesInst" title="Agente Económico" cell={(props) => <DropDownCellAllEntidadesInstVinicaEngarrafado {...props} tipoProduto="Todos"/>} width="600%"/>,
        <Column key={2} field="TipoProduto" title="Produto"   cell={(props) => <DropDownCellAllProdutoGridsEngarrafado {...props} tipoProduto="Todos"/>}  width="400%" />,
        <Column key={3} field="ProdutosSemConta" title="Produto sem conta" cell={DropDownCellAllProdutoGridsSemContas}  width="400%" />,
        <Column key={4} field="Ano" title="Ano" cell={NumericCell} width="120%"/>,
        <Column key={5} field="Cor" title="Cor" cell={DropDownCellCor} width="120%"/>,
        <Column key={6} field="NGarrafasVist" title="Nº de Garrafas" cell={NumericCell} width="120%"/>,
        <Column key={7} field="Capacidade" title="Capacidade" cell={DropDownCellCapacidades} width="120%"/>,
        //<Column key={6} field="IndisponivelEngarrafado" title="Ind. Engarrafado (L)" cell={NumericCell} width="120%"/>,
        //<Column key={7} field="ProdutoAcabado" title="Prod. Acabado (L)" cell={NumericCell}  width="120%"/>,
        <Column key={8} field="Observacoes" title="Observações" width="120%"/>,
        // <Column key={7} field="QTOutrasEntidades" title="Qt. Outras Entidades" cell={NumericCell} width="120%"/>,
        <Column key={9} field="QuantidadeApuradaEngarrafado" title="Quantidade"  cell={NumericCell} width="120%"/>,
        <Column key={10} cell={FiscalizacaoGrid9.ClassGrid9.CommandCell} width="90px" />
      ]}

      {ColumnsGridGranelVistoria = [
        // <Column key={1} field="VasilhaNumero" title="Nº Vasilha" cell={DropDownCellNVasilha}/>,
        // <Column key={2} field="Capacidade" title="Capacidade"/>,
        // <Column key={3} field="Falta" title="Falta(m)"/>,
        <Column key={1} field="EntidadesInst" title="Agente Económico" cell={(props) => <DropDownCellAllEntidadesInstVinicaGranel {...props} tipoProduto="Todos"/>} width="600%"/>,
        <Column key={2} field="TipoProduto" title="Produto"   cell={(props) => <DropDownCellAllProdutoGridsGranel {...props} tipoProduto="Todos" />}  width="400%" />,
        <Column key={3} field="ProdutosSemConta" title="Produto sem conta" cell={DropDownCellAllProdutoGridsSemContas}  width="400%" />,
        <Column key={4} field="Ano" title="Ano" cell={NumericCell} width="120%"/>,
        <Column key={5} field="Cor" title="Cor" cell={DropDownCellCor} width="120%"/>,
        <Column key={6} field="Tipo_Vasilha" title="Tipo Vasilha" cell={DropDownCellTipoVasilha} width="200%"/>,
        <Column key={7} field="N_Vasilha" title="Nº Vasilha" cell={DropDownCellNVasilha} width="90%"/>,
        <Column key={8} field="Capacidade_aferida" title="Cálculos Vasilha" cell={ButtonCell}  width="100%"/>,
        <Column key={9} field="Quantidade_aferida" title="Capacidade (L)" cell={NumericCell} width="120%"/>,
        <Column key={10} field="Falta" title="Falta (m)" cell={NumericCell} width="90%"/>,
        <Column key={11} field="Altura" title="Altura(m)"  cell={NumericCell} width="120%"/>,
        <Column key={12} field="QuantidadeApurada" title="Quantidade"  cell={NumericCell} width="120%"/>,
        <Column key={13} field="Observacoes" title="Observações" width="120%"/>,
        <Column key={14} cell={FiscalizacaoGrid10.ClassGrid10.CommandCell} width="90px" />
      ]}
      {ColumnsGridSelosVistoria = [
        <Column key={1} field="EntidadesInst" title="Agente Económico" cell={(props) => <DropDownCellAllEntidadesInstVinicaVendas {...props}/>} width="600%"/>,
        <Column key={2} field="TipoSelo" title="Tipo de Selo" cell={DropDownCellTipoSelo} width="140%"/>,
        <Column key={3} field="Serie_selosGarantia" title="Série" cell={DropDownCellSeriesSelo} width="120%"/>,
        <Column key={4} field="intervalosDisponiveis_selosGarantia" title="Intervalos Disponíveis" width="200%" cell= {DropDownCellIntervalosSelos}  />,
        <Column key={5} field="Nr_Selo_inicial_selosGarantia" title="Nº Selo Inicial" cell={NumericCellNrInicialFinal} width="120%"/>,
        <Column key={6} field="Nr_Selo_final_selosGarantia" title="Nº Selo Final" cell={NumericCellNrInicialFinal} width="120%"/>,
        <Column key={7} field="QTSelosCarteira" title="Qt.Selos Carteira" width="120%" cell={NumericCell}/>,
        <Column key={8} cell={FiscalizacaoGrid11.ClassGrid11.CommandCell} width="90px" />
      ]}
      // {ColumnsGridCapsulasVistoria = [
      //   // <Column key={1} field="Entidade" title="Entidade" />,
      //   <Column key={1} field="Serie" title="Série" width="120%"/>,
      //   <Column key={2} field="RegistoCapsulas" title="Registo" cell={DropDownCellRegisto} width="120%"/>,
      //   <Column key={3} field="Dimensao" title="Dimensão" width="120%"/>,
      //   <Column key={4} field="QTCapsulasCarteira" title="Qt.Cápsulas Carteira" width="120%"/>,
      //   <Column key={5} field="QTCapsulasAplicadas" title="QT.Cápsulas Aplicadas" width="120%"/>,
      //   <Column key={6} field="DenOrigem" title="Den. Origem" width="120%"/>,
      //   <Column key={7} cell={FiscalizacaoGrid12.ClassGrid12.CommandCell} width="90px" />
      // ]}
      {ColumnsGridVendasVistoria = [
        <Column key={1} field="EntidadesInst" title="Agente Económico" cell={(props) => <DropDownCellAllEntidadesInstVinicaVendas {...props} tipoProduto="Vendas"/>} width="600%"/>,
        <Column key={2} field="TipoProduto" title="Produto"   cell={(props) => <DropDownCellAllProdutoGridsVendas {...props} tipoProduto="Vendas" />}  width="400%" />,
        <Column key={3} field="ProdutosSemConta" title="Produto sem conta" cell={DropDownCellAllProdutoGridsSemContas}  width="400%" />,
        <Column key={4} field="Ano" title="Ano" cell={NumericCell} width="120%"/>,
        <Column key={5} field="Cor" title="Cor" cell={DropDownCellCor} width="120%"/>,
        <Column key={6}  field="DataVendas" title="Data" cell={NumericCell} width="140%"/>,
        <Column key={7} field="Documento" title="Documento" cell={DropDownCellDocumentos} width="150%"/>,
        <Column key={8} field="NumeroVendas" title="Nº"  width="120%"/>,
        <Column key={9} field="NumeroGarrafasVendas" title="Nº Garrafas" cell={NumericCell} width="120%"/>,
        <Column key={10} field="CapacidadeVendas" title="Capacidade" cell={DropDownCellCapacidades} width="120%"/>,
        <Column key={11} field="VolumeVendas" title="Volume (L)" cell={NumericCell} width="120%"/>,
        <Column key={12} field="Destinatario" title="Destinatário"  width="200%"/>,
        <Column key={13} field="Morada" title="Morada"  width="200%"/>,
        <Column key={14} field="Observacoes" title="Observações" width="120%"/>,
        <Column key={15} cell={FiscalizacaoGrid13.ClassGrid13.CommandCell} width="90px" />
      ]}
    }

    thisCreateGrid.handleChange();

    if(estadoQuery == 3){
      $(':input').prop("disabled", true);
    }

  }

  checkboxAfericao = (props) => {

    $('.' + props.target.className).prop('checked', false);

    $('#' + props.target.id).prop('checked', true);

  }

  handleChange = e => {

    var dataItemArray = [];
    this.state.columnsGrid = ColumnsGrid;
    this.state.ColumnsGridAEngarrafado = ColumnsGridAEngarrafado;
    this.state.ColumnsGridViatura = ColumnsGridViatura
    this.state.ColumnsGridSelosGarantia = ColumnsGridSelosGarantia
    this.state.ColumnsGridRotulos= ColumnsGridRotulos
    this.state.ColumnsGridSelosOutroAuto = ColumnsGridSelosOutroAuto
    this.state.ColumnsGridRotulosOutroAuto= ColumnsGridRotulosOutroAuto
    var ColumnList = this.props.columnList;

    this.state.ColumnsGridEngarrafadoVistoria = ColumnsGridEngarrafadoVistoria;
    this.state.ColumnsGridGranelVistoria = ColumnsGridGranelVistoria;
    this.state.ColumnsGridSelosVistoria = ColumnsGridSelosVistoria;
    // this.state.ColumnsGridCapsulasVistoria = ColumnsGridCapsulasVistoria;
    this.state.ColumnsGridVendasVistoria = ColumnsGridVendasVistoria;


    this.setState({ 
      ColumnList ,
      ColumnsGridAEngarrafado ,
      ColumnsGridViatura,
      ColumnsGridSelosGarantia,
      ColumnsGridSelosOutroAuto,
      ColumnsGridRotulosOutroAuto,
      ColumnsGridRotulos,

      ColumnsGridEngarrafadoVistoria,
      ColumnsGridGranelVistoria,
      ColumnsGridSelosVistoria,
      // ColumnsGridCapsulasVistoria,
      ColumnsGridVendasVistoria
    
    });
  }


  getLocationData = (key, value) => {
    console.log("2010 key and value ", key, value)
    var Distrito = ArrayDataFields
    let { codcon,coddis,codfrg } = { ...this.state };
    if (key === 'distrito_id') {
        coddis = value;
        codcon = "";
        codfrg = "";
    } 
    else if (key === 'country_id') {
        codcon = value;
        codfrg = "";
    } 
    else if (key === 'fregusia_id') {
        codfrg = value;
    }
    this.setState({
        coddis, 
        codcon,
        codfrg
    })
  }


  handleChangeAuto17 = e => {
    if(e != null){
      $(".inlineCheckbox").not(this).prop('checked', false);
      $(e.target).prop('checked', true);
    }else{

    }
    


    console.log("entrou auto 17")
      var granel = $("#inlineCheckbox1").is(":checked");
      var engarrafado = $("#inlineCheckbox2").is(":checked");
      var viatura = $("#inlineCheckbox3").is(":checked");
      var selosGarantia = $("#inlineCheckbox4").is(":checked");
      var rotulos = $("#inlineCheckbox5").is(":checked");

      var rotulosOutroAuto = $("#inlineCheckbox6").is(":checked");
      var selosOutroAuto = $("#inlineCheckbox7").is(":checked");

      // if(granel == true || engarrafado == true){
      //   $("#inlineCheckbox3").attr("disabled" ,true)
      // }else{
      //   $("#inlineCheckbox3").attr("disabled" ,false)
      // }
      if(granel == true){
        //$("#flexCheckDefault1").prop("checked", true);
        //$("#flexCheckDefault1").prop("disabled", true);
        if($("#Motivo_fisc :selected").val() == '45'){
          {ColumnsGrid = [
            <Column key={1} field="Tipo_Vasilha" title="Tipo Vasilha" cell={DropDownCellTipoVasilha} width="120%" />,
            <Column key={2} field="N_Vasilha_granel" title="Nº Vasilha" cell={DropDownCellNVasilha} width="120%"/>,
            <Column key={3} field="Capacidade_aferida" title="Cálculos Vasilha" cell={ButtonCell} width="120%"/>,
            <Column key={4} field="Capacidade_aferida" title="Capacidade Aferida (L)" cell={NumericCell} width="120%"/>,
            <Column key={5} field="Falta_granel" title="Falta (m)" cell={NumericCell} width="120%"/>,
            <Column key={6} field="Quantidade_apurada" title="Quantidade Apurada (L)" cell={NumericCell} width="120%"/>,
            // <Column key={7} field="Produto_NC_GA_IG_granel" title="Produto" cell={DropDownCellProduto} width="120%"/>,
            <Column key={7} field="TipoProduto" title="Produto"   cell={(props) => <DropDownCellAllProdutoGridsEngarrafado {...props} tipoProduto="colheita"/>}  width="400%" />,
            // <Column key={8} field="ProdutosSemConta" title="Produto sem conta" cell={DropDownCellAllProdutoGridsSemContas}  width="400%" />,
            // <Column key={9} field="Ano" title="Ano" cell={NumericCell} width="120%"/>,
            // <Column key={10} field="Cor" title="Cor" cell={DropDownCellCor} width="120%"/>,

            <Column key={8} field="ProdutoAdicionar" title="Produto a  adicionar" cell={DropDownCellAllProdutoAdicionar}  width="400%" />,
            <Column key={6} field="QuantidadeAdicionada" title="Quantidade Adicionada (L/Kg)" cell={NumericCell} width="120%"/>,
            <Column key={8} field="ProdutoObter" title="Produto a  Obter" cell={DropDownCellAllProdutoObter}  width="400%" />,
            <Column key={6} field="QuantidadeFinal" title="Quantidade Final (L/Kg)" cell={NumericCell} width="120%"/>,

            <Column key={8} title="Selagem" headerClassName="gridStyleTitle">
              <Column key={9} field="SelosSeguranca_granel" title="Selos de Segurança" cell={SelectCellSelosSelagem} width="120%"/>
              <Column key={10} field="Etiquetas_selagem_granel" title="Etiquetas" cell={SelectCellEtiquetasSelagem} width="120%"/>
              <Column key={11} field="Sinetes_granel" title="Sinetes" width="90%"/>
            </Column>,
             <Column key={12} title="Recolha de Amostras" headerClassName="gridStyleTitle">
              <Column key={13} field="NGarrafasAmostra_granel" title="Nº Garrafas" cell={NumericCell} width="120%"/>
              <Column key={14} field="Capacidade_Amostra_granel" title="Capacidade" cell={DropDownCellCapacidades} width="120%"/>
              <Column key={15} field="Etiquetas_RecolhaAmostra_granel" title="Etiquetas de Segurança" cell={SelectCellEtiquetas} width="120%"/>
           </Column>,
            <Column key={16} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
          ]}
        }else{
          {ColumnsGrid = [
            <Column key={1} field="Tipo_Vasilha" title="Tipo Vasilha" cell={DropDownCellTipoVasilha} width="120%" />,
            <Column key={2} field="N_Vasilha_granel" title="Nº Vasilha" cell={DropDownCellNVasilha} width="120%"/>,
            <Column key={3} field="Capacidade_aferida" title="Cálculos Vasilha" cell={ButtonCell} width="120%"/>,
            <Column key={4} field="Capacidade_aferida" title="Capacidade Aferida (L)" cell={NumericCell} width="120%"/>,
            <Column key={5} field="Falta_granel" title="Falta (m)" cell={NumericCell} width="120%"/>,
            <Column key={6} field="Quantidade_apurada" title="Quantidade Apurada (L)" cell={NumericCell} width="120%"/>,
            // <Column key={7} field="Produto_NC_GA_IG_granel" title="Produto" cell={DropDownCellProduto} width="120%"/>,
            <Column key={7} field="TipoProduto" title="Produto"   cell={(props) => <DropDownCellAllProdutoGridsEngarrafado {...props} tipoProduto="colheita"/>}  width="400%" />,
            <Column key={8} field="ProdutosSemConta" title="Produto sem conta" cell={DropDownCellAllProdutoGridsSemContas}  width="400%" />,
            <Column key={9} field="Ano" title="Ano" cell={NumericCell} width="120%"/>,
            <Column key={10} field="Cor" title="Cor" cell={DropDownCellCor} width="120%"/>,
  
            <Column key={8} title="Selagem" headerClassName="gridStyleTitle">
              <Column key={9} field="SelosSeguranca_granel" title="Selos de Segurança" cell={SelectCellSelosSelagem} width="120%"/>
              <Column key={10} field="Etiquetas_selagem_granel" title="Etiquetas" cell={SelectCellEtiquetasSelagem} width="120%"/>
              <Column key={11} field="Sinetes_granel" title="Sinetes" width="90%"/>
            </Column>,
             <Column key={12} title="Recolha de Amostras" headerClassName="gridStyleTitle">
              <Column key={13} field="NGarrafasAmostra_granel" title="Nº Garrafas" cell={NumericCell} width="120%"/>
              <Column key={14} field="Capacidade_Amostra_granel" title="Capacidade" cell={DropDownCellCapacidades} width="120%"/>
              <Column key={15} field="Etiquetas_RecolhaAmostra_granel" title="Etiquetas de Segurança" cell={SelectCellEtiquetas} width="120%"/>
           </Column>,
            <Column key={16} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
          ]}
        } 
      }
      if(engarrafado == true){
        //$("#flexCheckDefault1").prop("checked", false);
        //$("#flexCheckDefault1").prop("disabled", false);
        {ColumnsGridAEngarrafado = [
          <Column key={1} field="Produto_NC_GA_IG_engarrafado" title="Conta Corrente" cell={(props) => <DropDownCellAllProdutoGridsEngarrafadoSelagem {...props} tipoProduto="Engarrafado"/>}  width="400%"/>,
          <Column key={8} field="ProdutosSemConta" title="Produto sem conta" cell={DropDownCellAllProdutoGridsSemContas}  width="400%" />,
          <Column key={9} field="Ano" title="Ano" cell={NumericCell} width="120%"/>,
          <Column key={10} field="Cor" title="Cor" cell={DropDownCellCor} width="120%"/>,
          <Column key={2} cell={DropDownCellCorrelativaProduto} field="Correlativa_engarrafado" title="Nº de Rotulagem" width="120%"/>,
          <Column key={3} field="NLote_engarrafado" title="Nº Lote" cell={InputCellNLote} width="120%"/>,
          <Column key={5} field="Capacidade_engarrafado" title="Capacidade (L)" className="CapacidadeCell" cell={DropDownCellCapacidadesFDO} width="120%"/>,
          <Column key={4} field="NGarrafasDevolvidas_engarrafado" title="Nº Garrafas" width="120%"/>,
          <Column key={6} field="Volume_engarrafado" title="Volume (L)" cell={NumericCell} width="120%"/>,
          <Column key={7} title="Selagem" headerClassName="gridStyleTitle">
            <Column key={8} field="SelosSeguranca_engarrafado" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
            <Column key={9} field="Etiquetas_selagem_engarrafado" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
            <Column key={10} field="Sinetes_engarrafado" title="Sinetes" width="120%"/>
          </Column>,
          <Column key={11} title="Recolha de Amostras" headerClassName="gridStyleTitle">
            <Column key={12} field="NGarrafas_engarrafado" title="Nº Garrafas" cell={NumericCell} width="120%"/>
            <Column key={13} field="Capacidade__engarrafado" title="Capacidade" cell={DropDownCellCapacidades} width="120%"/>
            <Column key={14} field="Etiquetas_RecolhaAmostra_engarrafado" title="Etiquetas de Segurança" cell={SelectCellEtiquetas} width="120%"/>
          </Column>,
          <Column key={15} cell={FiscalizacaoGrid6.ClassGrid6.CommandCell} width="90px" />
        ]}
      }
      if(viatura == true){
        // $("#flexCheckDefault1").prop("checked", false);
        // $("#flexCheckDefault1").prop("disabled", false);
        // $("#inlineCheckbox1").attr("disabled" ,true)
        // $("#inlineCheckbox2").attr("disabled" ,true)
        {ColumnsGridViatura = [
          <Column key={1} field="Matricula_viatura" title="Matricula"  width="120%"/>,
          <Column key={2} field="Doc_Transporte_viatura" title="Doc. Transporte"  width="120%"/>,
          <Column key={3} field="Cert_precedencia_viatura" title="Cert. Procedência" width="120%" />,
          <Column key={4} field="RCDO_viatura" title="RCDO"  />,
          <Column key={5} field="Volume_viatura" title="Volume" cell={NumericCell} width="120%" />,
          <Column key={6} title="Selagem" headerClassName="gridStyleTitle">
            <Column key={7} field="SelosSeguranca_viatura" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
            <Column key={8} field="Etiquetas_selagem_viatura" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
            <Column key={9} field="Sinetes_viatura" title="Sinetes" width="120%"/>
          </Column>,
          <Column key={10} cell={FiscalizacaoGrid3.ClassGrid3.CommandCell} width="90px" />
        ]}
      }else{
        // $("#inlineCheckbox1").attr("disabled" ,false)
        // $("#inlineCheckbox2").attr("disabled" ,false)
      }
      if(selosGarantia == true){
        // $("#flexCheckDefault1").prop("checked", false);
        // $("#flexCheckDefault1").prop("disabled", false);
        {ColumnsGridSelosGarantia = [
          <Column key={1} field="TipoSelo" title="Tipo de Selo" cell={DropDownCellTipoSelo} width="120%"/>,
          <Column key={2} field="Serie_selosGarantia" title="Série" cell={DropDownCellSeriesSelo} width="120%"/>,
          <Column key={3} field="intervalosDisponiveis_selosGarantia" title="Intervalos Disponíveis" width="120%" cell= {DropDownCellIntervalosSelos}  />,
          <Column key={4} field="Nr_Selo_inicial_selosGarantia" title="Nº Selo Inicial" cell={NumericCellNrInicialFinal} width="120%"/>,
          <Column key={5} field="Nr_Selo_final_selosGarantia" title="Nº Selo Final" cell={NumericCellNrInicialFinal} width="120%"/>,
          <Column key={6} field="Quantidade_selosGarantia" title="Quantidade" cell={NumericCell} width="120%"/>,
          <Column key={7} title="Selagem" headerClassName="gridStyleTitle">
            <Column key={8} field="SelosSeguranca" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
            <Column key={9} field="Etiquetas_selagem_selosGarantia" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
            <Column key={10} field="Sinetes_selosGarantia" title="Sinetes" width="120%"/>
          </Column>,
          <Column key={11} cell={FiscalizacaoGrid4.ClassGrid4.CommandCell} width="90px" />
        ]}
      }
      if(rotulos == true){
        // $("#flexCheckDefault1").prop("checked", false);
        // $("#flexCheckDefault1").prop("disabled", false);
        {ColumnsGridRotulos = [
          <Column key={1} field="tipo_rotulos" title="Tipo" cell={DropDownCellRotulo} width="120%"/>,
          <Column key={2} cell={DropDownCellRegisto} field="Registo_rotulos" title="Nº de Certificação" width="120%"/>,
          <Column key={3} cell={DropDownCellCorrelativa} field="Correlativa_rotulos" title="Nº de Rotulagem" width="300%"/>,
          <Column key={4} field="Descricao_rotulos" title="Descrição" width="120%" />,
          <Column key={5} field="Quantidade_rotulos" title="Quantidade" cell={NumericCell} width="120%"/>,
          <Column key={6} title="Selagem" headerClassName="gridStyleTitle">
          <Column key={7} field="SelosSegurancas_rotulos" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
          <Column key={8} field="Etiquetas_selagem_rotulos" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
          <Column key={9} field="Sinetes_rotulos" title="Sinetes" width="120%"/>
          </Column>,
          <Column key={10} cell={FiscalizacaoGrid5.ClassGrid5.CommandCell} width="90px" />
        ]}
      }
      if(rotulosOutroAuto == true){
        // $("#flexCheckDefault1").prop("checked", false);
        // $("#flexCheckDefault1").prop("disabled", false);
        {ColumnsGridRotulosOutroAuto = [
          <Column key={1} field="tipo_rotulos" title="Tipo" cell={DropDownCellRotulo} />,
          <Column key={2} cell={DropDownCellRegisto} field="Registo_rotulos" title="Nº de Certificação" />,
          <Column key={3} cell={DropDownCellCorrelativa} field="Correlativa_rotulos" title="Nº de Rotulagem" />,
          <Column key={4} field="Descricao_rotulos" title="Descrição (livre)" />,
          <Column key={5} field="Quantidade_rotulos" title="Quantidade" cell={NumericCell} />,

        <Column key={6} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
        ]}
      }
      if(selosOutroAuto == true){
        if(selosOutroAuto == true){
          {ColumnsGridSelosOutroAuto = [
          <Column key={1} field="TipoSelo" title="Tipo de Selo" cell={DropDownCellTipoSelo} width="120%"/>,
          <Column key={2} field="Serie_selosGarantia" title="Série" cell={DropDownCellSeriesSelo} width="120%"/>,
          <Column key={3} field="intervalosDisponiveis_selosGarantia" title="Intervalos Disponíveis" width="120%" cell= {DropDownCellIntervalosSelos}  />,
          <Column key={4} field="Nr_Selo_inicial_selosGarantia" title="Nº Selo Inicial" cell={NumericCellNrInicialFinal} width="120%"/>,
          <Column key={5} field="Nr_Selo_final_selosGarantia" title="Nº Selo Final" cell={NumericCellNrInicialFinal} width="120%"/>,
          <Column key={6} field="Quantidade_selosGarantia" title="Quantidade" cell={NumericCell} width="120%"/>,
          <Column key={7} field="Produto_Selos" title="Produto" cell={NumericCell} width="120%"/>,
          <Column key={8} cell={DropDownCellCorrelativaProduto} field="Correlativa_selos" title="Nº de Rotulagem" width="120%"/>,
          <Column key={9} cell={FiscalizacaoGrid4.ClassGrid4.CommandCell} width="90px" />
          ]}
        }
      }
    granelcheck = granel
    engarrafadocheck = engarrafado
    viaturacheck = viatura
    selosGarantiacheck = selosGarantia
    rotuloscheck = rotulos
  
    rotulosOutroAutocheck = rotulosOutroAuto  
    selosOutroAutocheck = selosOutroAuto   

    thisCreateGrid.handleChange();
  
      
  
    }
    handleChangeNrRequisicao  = e => {
      $("#inlineCheckbox1").prop("checked" , true);
      this.handleChangeAuto17();
        (async () => { 
            const data = {"idRequisicao" : parseInt(e.target.value)}
            const Requisicao = await services.apiCall.requestApi(
            "/Fiscalizacao/GetRequisicaoDetalhe",
            data,
            "get"
            );

            console.log(Requisicao, "REQUISICAOOOOOO")
            if (Requisicao) {
              FiscalizacaoGrid.ClassGrid.removeAllRows();
              const items = await getItems(Requisicao);
              this.setState({
                  data: items,
                  Columns: this.props.columnList
              });
          }
        })();
    }
  // getDefaultValue() {
  //   return  options.find(option => option.value == token)
  // }
  static handleChangeAuto17Desc = e => {
    // $(".inlineCheckbox").not(this).prop('checked', false);
    // if(e){
    //   $(e.target).prop('checked', true);
    // }
   
  console.log("entrou auto 17")
    var granel = $("#inlineCheckbox1").is(":checked");
    var engarrafado = $("#inlineCheckbox2").is(":checked");
    var viatura = $("#inlineCheckbox3").is(":checked");
    var selosGarantia = $("#inlineCheckbox4").is(":checked");
    var rotulos = $("#inlineCheckbox5").is(":checked");
    
    var rotulosOutroAuto = $("#inlineCheckbox6").is(":checked");
    var selosOutroAuto = $("#inlineCheckbox7").is(":checked");

    // if(granel == true || engarrafado == true){
    //   $("#inlineCheckbox3").attr("disabled" ,true)
    // }else{
    //   $("#inlineCheckbox3").attr("disabled" ,false)
    // }
    if(granel == true){
      // $("#flexCheckDefault1").prop("checked", true);
      // $("#flexCheckDefault1").prop("disabled", true);
      {ColumnsGrid = [
        <Column key={1} field="Tipo_Vasilha" title="Tipo Vasilha" cell={DropDownCellTipoVasilha} width="120%"/>,
        <Column key={2} field="N_Vasilha_granel" title="Nº Vasilha" cell={DropDownCellNVasilha} width="120%"/>,
        <Column key={3} field="CalculoVasilha" title="Cálculos Vasilha" cell={ButtonCell} width="120%"/>,
        <Column key={4} field="Capacidade_aferida" title="Capacidade Aferida (L)" cell={NumericCell} width="120%"/>,
        <Column key={5} field="Falta_granel" title="Falta (m)" cell={NumericCell} width="120%"/>,
        <Column key={6} field="Quantidade_apurada" title="Quantidade Apurada (L)" cell={NumericCell} width="120%"/>,
        <Column key={7} field="Produto_NC_GA_IG_granel" title="Produto" cell={DropDownCellProduto} width="120%"/>,
        <Column key={8} title="Selagem" headerClassName="gridStyleTitle">
          <Column key={9} field="SelosSeguranca_granel" title="Selos de Segurança" cell={SelectCellSelosSelagem} width="120%"/>
          <Column key={10} field="Etiquetas_selagem_granel" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
          <Column key={11} field="Sinetes_granel" title="Sinetes" width="90%"/>
        </Column>,
      //    <Column key={12} title="Recolha de Amostras" headerClassName="gridStyleTitle">
      //     <Column key={13} field="NGarrafasAmostra_granel" title="Nº Garrafas" cell={NumericCell} width="120%"/>
      //     <Column key={14} field="Capacidade_Amostra_granel" title="Capacidade" cell={DropDownCellCapacidades} width="120%" />
      //     <Column key={15} field="Etiquetas_RecolhaAmostra_granel" title="Etiquetas de Segurança" cell={SelectCellEtiquetas} width="120%"/>
      //  </Column>,
        <Column key={16} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
      ]}
      
    }
    if(engarrafado == true){
      // $("#flexCheckDefault1").prop("checked", false);
      // $("#flexCheckDefault1").prop("disabled", false);
      {ColumnsGridAEngarrafado = [
        <Column key={1} field="Produto_NC_GA_IG_engarrafado" title="Conta Corrente" cell={DropDownCellProduto2} width="120%"/>,
        <Column key={2} cell={DropDownCellCorrelativaProduto} field="Correlativa_engarrafado" title="Nº de Rotulagem" width="120%"/>,
        <Column key={3} field="NLote_engarrafado" title="Nº Lote" cell={InputCellNLote} width="120%"/>,
        <Column key={4} field="NGarrafasDevolvidas_engarrafado" title="Nº Garrafas" width="120%"/>,
        <Column key={5} field="Capacidade_engarrafado" title="Capacidade (L)" className="CapacidadeCell" editable={false} width="120%"/>,
        <Column key={6} field="Volume_engarrafado" title="Volume (L)" cell={NumericCell} width="120%"/>,
        <Column key={7} title="Selagem" headerClassName="gridStyleTitle">
          <Column key={8} field="SelosSeguranca_engarrafado" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
          <Column key={9} field="Etiquetas_selagem_engarrafado" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
          <Column key={10} field="Sinetes_engarrafado" title="Sinetes" width="120%"/>
        </Column>,
        // <Column key={11} title="Recolha de Amostras" headerClassName="gridStyleTitle">
        //   <Column key={12} field="NGarrafas_engarrafado" title="Nº Garrafas" cell={NumericCell} width="120%"/>
        //   <Column key={13} field="Capacidade__engarrafado" title="Capacidade" cell={DropDownCellCapacidades} width="120%"/>
        //   <Column key={14} field="Etiquetas_RecolhaAmostra_engarrafado" title="Etiquetas de Segurança" cell={SelectCellEtiquetas} width="120%"/>
        // </Column>,
        <Column key={15} cell={FiscalizacaoGrid6.ClassGrid6.CommandCell} width="90px" />
      ]}
    }
    if(viatura == true){
      // $("#flexCheckDefault1").prop("checked", false);
      // $("#flexCheckDefault1").prop("disabled", false);
      // $("#inlineCheckbox1").attr("disabled" ,true)
      // $("#inlineCheckbox2").attr("disabled" ,true)
      {ColumnsGridViatura = [
        <Column key={1} field="Matricula_viatura" title="Matricula" width="120%" />,
        <Column key={2} field="Doc_Transporte_viatura" title="Doc. Transporte"  width="120%"/>,
        <Column key={3} field="Cert_precedencia_viatura" title="Cert. Procedência" width="120%" />,
        <Column key={4} field="RCDO_viatura" title="RCDO"  width="120%"/>,
        <Column key={5} field="Volume_viatura" title="Nº Garrafas" cell={NumericCell} width="120%"/>,
        <Column key={6} title="Selagem" headerClassName="gridStyleTitle">
          <Column key={7} field="SelosSeguranca_viatura" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
          <Column key={8} field="Etiquetas_selagem_viatura" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
          <Column key={9} field="Sinetes_viatura" title="Sinetes" width="120%"/>
        </Column>,
        <Column key={10} cell={FiscalizacaoGrid3.ClassGrid3.CommandCell} width="90px" />
      ]}
    }else{
      // $("#inlineCheckbox1").attr("disabled" ,false)
      // $("#inlineCheckbox2").attr("disabled" ,false)
    }
    if(selosGarantia == true){
      // $("#flexCheckDefault1").prop("checked", false);
      // $("#flexCheckDefault1").prop("disabled", false);
      {ColumnsGridSelosGarantia = [
        <Column key={1} field="TipoSelo" title="Tipo de Selo" cell={DropDownCellTipoSelo} width="120%"/>,
        <Column key={2} field="Serie_selosGarantia" title="Série" cell={DropDownCellSeriesSelo} width="120%"/>,
        <Column key={3} field="intervalosDisponiveis_selosGarantia" title="Intervalos Disponíveis" width="120%" cell= {DropDownCellIntervalosSelos}  />,
        <Column key={4} field="Nr_Selo_inicial_selosGarantia" title="Nº Selo Inicial" cell={NumericCellNrInicialFinal} width="120%"/>,
        <Column key={5} field="Nr_Selo_final_selosGarantia" title="Nº Selo Final" cell={NumericCellNrInicialFinal} width="120%"/>,
        <Column key={6} field="Quantidade_selosGarantia" title="Quantidade" cell={NumericCell} width="120%"/>,
        <Column key={7} title="Selagem" headerClassName="gridStyleTitle">
          <Column key={8} field="SelosSeguranca" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
          <Column key={9} field="Etiquetas_selagem_selosGarantia" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
          <Column key={10} field="Sinetes_selosGarantia" title="Sinetes" width="120%"/>
        </Column>,
        <Column key={11} cell={FiscalizacaoGrid4.ClassGrid4.CommandCell} width="90px" />
      ]}
    }
    if(rotulos == true){
      // $("#flexCheckDefault1").prop("checked", false);
      // $("#flexCheckDefault1").prop("disabled", false);
      {ColumnsGridRotulos = [
        <Column key={1} field="tipo_rotulos" title="Tipo" cell={DropDownCellRotulo} width="120%"/>,
        <Column key={2} cell={DropDownCellRegisto} field="Registo_rotulos" title="Nº de Certificação" width="120%"/>,
        <Column key={3} cell={DropDownCellCorrelativa} field="Correlativa_rotulos" title="Nº de Rotulagem" width="300%"/>,
        <Column key={4} field="Descricao_rotulos" title="Descrição" width="120%" />,
        <Column key={5} field="Quantidade_rotulos" title="Quantidade" cell={NumericCell} width="120%"/>,
        <Column key={6} title="Selagem" headerClassName="gridStyleTitle">
        <Column key={7} field="SelosSegurancas_rotulos" title="Selos de Segurança" cell={SelectCellSelos} width="120%"/>
        <Column key={8} field="Etiquetas_selagem_rotulos" title="Etiquetas" cell={SelectCellEtiquetas} width="120%"/>
        <Column key={9} field="Sinetes_rotulos" title="Sinetes" width="120%"/>
        </Column>,
        <Column key={10} cell={FiscalizacaoGrid5.ClassGrid5.CommandCell} width="90px" />
      ]}
    }

    if(rotulosOutroAuto == true){
      // $("#flexCheckDefault1").prop("checked", false);
      // $("#flexCheckDefault1").prop("disabled", false);
      {ColumnsGridRotulosOutroAuto = [
        <Column key={1} field="tipo_rotulos" title="Tipo" cell={DropDownCellRotulo} width="120%"/>,
        <Column key={2} cell={DropDownCellRegisto} field="Registo_rotulos" title="Nº de Certificação" width="120%"/>,
        <Column key={3} cell={DropDownCellCorrelativa} field="Correlativa_rotulos" title="Nº de Rotulagem" width="120%"/>,
        <Column key={4} field="Descricao_rotulos" title="Descrição (livre)"  width="120%"/>,
        <Column key={5} field="Quantidade_rotulos" title="Quantidade" cell={NumericCell} width="120%" />,

      <Column key={6} cell={FiscalizacaoGrid.ClassGrid.CommandCell} width="90px" />
      ]}
    }
    if(selosOutroAuto == true){
      // $("#flexCheckDefault1").prop("checked", false);
      // $("#flexCheckDefault1").prop("disabled", false);
      {ColumnsGridSelosOutroAuto = [
        <Column key={1} field="TipoSelo" title="Tipo de Selo" cell={DropDownCellTipoSelo} width="120%"/>,
        <Column key={2} field="Serie_selosGarantia" title="Série" cell={DropDownCellSeriesSelo} width="120%"/>,
        <Column key={3} field="intervalosDisponiveis_selosGarantia" title="Intervalos Disponíveis" width="120%" cell= {DropDownCellIntervalosSelos}  />,
        <Column key={4} field="Nr_Selo_inicial_selosGarantia" title="Nº Selo Inicial" cell={NumericCellNrInicialFinal} width="120%"/>,
        <Column key={5} field="Nr_Selo_final_selosGarantia" title="Nº Selo Final" cell={NumericCellNrInicialFinal} width="120%"/>,
        <Column key={6} field="Quantidade_selosGarantia" title="Quantidade" cell={NumericCell} width="120%"/>,
        <Column key={7} field="Produto_Selos" title="Produto" cell={NumericCell} width="120%" />,
        <Column key={8} cell={DropDownCellCorrelativaProduto} field="Correlativa_selos" title="Nº de Rotulagem" width="120%"/>,
        <Column key={9} cell={FiscalizacaoGrid4.ClassGrid4.CommandCell} width="90px" />
      ]}
    }

    granelcheck = granel
    engarrafadocheck = engarrafado
    viaturacheck = viatura
    selosGarantiacheck = selosGarantia
    rotuloscheck = rotulos

    rotulosOutroAutocheck = rotulosOutroAuto  
    selosOutroAutocheck = selosOutroAuto   
    thisCreateGrid.handleChange();
  }

  handleChangeCheckboxesAvaliacao = e => {
    var checkedCheckboxes = $(".ChecksVerificacao:checked");
    var arrayNao = [];
    var arraySim = [];
    var arrayNA = [];
     // Filtrar e verificar os labels associados
     checkedCheckboxes.each(function(index,item) {
         var labelText = item.labels[0].textContent;
         if (labelText === "Não") {
             arrayNao.push(item);
         } else if (labelText === "Sim") {
             arraySim.push(item);
         } else if (labelText === "N/A") {
             arrayNA.push(item);
         }
     });

     if(arrayNao.length == 0 && arraySim.length != 0){
         $("#ParecerCheckSim").prop("checked" , true)
         $("#MelhoriaReceita").addClass("d-none");
     }
     if(arraySim.length == 0 && arrayNao.length != 0){
         $("#ParecerCheckNao").prop("checked" , true) 
         $("#MelhoriaReceita").addClass("d-none");
     }

     if(arraySim.length != 0 && arrayNao.length != 0){
         $("#ParecerCheckNA").prop("checked" , true) 
         $("#MelhoriaReceita").removeClass("d-none");
     }
}

  render() {

    // Função para type 

    $(document).on('input', ':input[type="number"][maxlength]', function () {
      if (this.value.length > this.maxLength) {
          this.value = this.value.slice(0, this.maxLength); 
      }
    });

    thisCreateGrid = this;
   
   
    $("#ParecerFiscalizacao").addClass("d-none")
    var leftNavFields;
    
   
    if(typeAutoValue == "1"){

      return(
        
        <div>
          <div className="head position-relative mb-4">
          <h2>Vasilhas</h2>
          </div>
          <div className="row">
              <div className="col-12" id="id-div-fiscalizacao-grid">
                <FiscalizacaoGrid.ClassGrid
                  date={new Date()}
                  parsed={this.state.parsed}
                  changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                  linkData={this.state.linkData}
                  trans_methods={this.state.trans_methods}
                  columnList={this.state.columnsGrid} />
              </div>
          </div>
        </div>
      )

    }else if(typeAutoValue == "2"){

      return(
        <div>
          <div className="head position-relative mb-4">
            <h2>Detalhes - Local da Colheita</h2>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Certificado Procedência</label>
                <input className="input-1 certificado_procedencia" name="certificado_procedencia" id="certificado_procedencia"></input>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Proveniência</label>
                <input className="input-1 Proveniencia" name="Proveniencia" id="Proveniencia"></input>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Destinatário</label>
                <input className="input-1 Destinatario" name="Destinatario" id="Destinatario"></input>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Transportador</label>
                <input className="input-1 Transportador" name="Transportador" id="Transportador"></input>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Matrícula</label>
                <input className="input-1 Matrícula" name="Matrícula" id="Matrícula"></input>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Nº Contentores</label>
                <input className="input-1 NContentores" name="NContentores" id="NContentores" type="number"></input>
              </div>
            </div>    
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Volume (L)</label>
                <input className="input-1 VolumeL" name="VolumeL" id="VolumeL" type="number"></input>
              </div>
            </div>  
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Doc. Transporte</label>
                <input className="input-1 DocTransporte" name="DocTransporte" id="DocTransporte" ></input>
              </div>
            </div>
          </div>
          <div className="row grid-style-width">
              <div className="col-12" id="id-div-fiscalizacao-grid">
                <FiscalizacaoGrid.ClassGrid
                  date={new Date()}
                  parsed={this.state.parsed}
                  changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                  linkData={this.state.linkData}
                  trans_methods={this.state.trans_methods}
                  columnList={this.state.columnsGrid} />
              </div>
          </div>
        </div>
      )

    }else if(typeAutoValue == "3"){
      return(

     
        <div className="row grid-style-width">
          {/* <div className="col-3 input-style-float">
          
            <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
              <label style={{ marginBottom : "0"}}>Origem da Devolução</label>
              <input className="input-1 OrigemDevolucao" name="OrigemDevolucao" id="OrigemDevolucao"></input>
            </div>
          </div> */}
          <div className="col-12" id="id-div-fiscalizacao-grid">
            <FiscalizacaoGrid.ClassGrid
              date={new Date()}
              parsed={this.state.parsed}
              changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
              linkData={this.state.linkData}
              trans_methods={this.state.trans_methods}
              columnList={this.state.columnsGrid} />
          </div>
        </div>
       
      )

    }else if(typeAutoValue == "4"){

      {var ColumnsGridAfericao = [
        <Column key={1}  cell={DropDownCellRegisto} field="Registo_DO" title="Nº de Certificação" width={"100px"}/>,

        <Column key={2} title="Quantidade Base de dados (Litros)" headerClassName="gridStyleTitle">
          <Column key={3} field="IndispGranelQBD" title="Indisp. Granel" cell={NumericCell} width={"100px"}/>
          <Column key={4} field="IndispEngaQBD"  title="Indisp. Enga" cell={NumericCell} width={"100px"}/>
          <Column key={5} field="ProdutoAcabadoQBD"  title="Produto Acabado" cell={NumericCell} width={"100px"}/>
          <Column key={6} field="TotalQBD"  title="Total" cell={NumericCell} />
          </Column>,
        
        <Column key={7} title="Quantidade Aferida (Litros)" headerClassName="gridStyleTitle">
          <Column key={8} field="IndispGranelQA" title="Indisp. Granel" cell={NumericCell} width={"100px"}/>
          <Column key={9} field="IndispEngaQA"  title="Indisp. Enga" cell={NumericCell} width={"100px"}/>
          <Column key={10} field="ProdutoAcabadoQA"  title="Produto Acabado" cell={NumericCell} width={"100px"}/>
          <Column key={11} field="VendasQA"  title="Vendas" cell={NumericCell} width={"100px"}/>
          <Column key={12} field="TotalQA"  title="Total" cell={NumericCell} width={"100px"}/>
          </Column>,

        <Column key={13} title="Quantidade Total (Litros)" headerClassName="gridStyleTitle">
          <Column key={14} field="IndispGranelQT" title="Indisp. Granel" cell={NumericCell} width={"100px"}/>
          <Column key={15} field="IndispEngaQT"  title="Indisp. Enga" cell={NumericCell} width={"100px"}/>
          <Column key={16} field="ProdutoAcabadoQT"  title="Produto Acabado" cell={NumericCell} width={"100px"}/>
          <Column key={17} field="TotalQT"  title="Total" cell={NumericCell} width={"100px"}/>
          </Column>,

        <Column key={18} cell={FiscalizacaoGrid2.ClassGrid2.CommandCell} width="90px" />

      ]}


      return(
        <div className="row grid-style-width p20">

          <div className="head position-relative mb-4"><h2>Amostras Recolhidas</h2></div>

          <div className="col-12 marginBottom30" id="id-div-fiscalizacao-grid">
            <FiscalizacaoGrid.ClassGrid
              date={new Date()}
              parsed={this.state.parsed}
              changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
              linkData={this.state.linkData}
              trans_methods={this.state.trans_methods}
              columnList={this.state.columnsGrid} />
          </div>

          <div className="head position-relative mb-4"><h2>Aferição</h2></div>

          <div className="position-relative ckbx-m-20">
            <div className="position-relative">
              <input type="checkbox" className="label-verified-accordance" id="id-label-verified-accordance" name="Label-accordance" value="true" onChange={this.checkboxAfericao}/><label for="id-label-verified-accordance">Os rótulos e contra-rótulos verificados estão em conformidade</label>
            </div>
            <div className="position-relative">
              <input type="checkbox" className="label-verified-accordance" id="id-label-verified-not-accordance" name="Label-accordance" value="false" onChange={this.checkboxAfericao}/><label for="id-label-verified-not-accordance">Os rótulos e contra-rótulos verificados não estão em conformidade</label>
            </div>
            <div className="position-relative">
              <input type="checkbox" className="label-verified-accordance" id="id-label-verified-not-accordance2" name="Label-accordance" value="false" onChange={this.checkboxAfericao}/><label for="id-label-verified-not-accordance2">Não foram verificados os rótulos e contra-rótulos</label>
            </div>
          </div>
          
          <div className="col-12" id="id-div-Afericao-grid">
            <FiscalizacaoGrid2.ClassGrid2
              date={new Date()}
              parsed={this.state.parsed}
              changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
              linkData={this.state.linkData}
              trans_methods={this.state.trans_methods}
              columnList={ColumnsGridAfericao} />
          </div>


        </div>

        

      )

    }else if(typeAutoValue == "5"){
      return(
        
        <div className="row grid-style-width">
          <div className="head position-relative mb-4 ml-3">
            <h2>Detalhes - Despejo</h2>
          </div>
          <div className="col-12" id="id-div-fiscalizacao-grid">
            <div className="col-md-12 pl-0">
            <div className="position-relative ml-2">
              <input
                type="checkbox"
                className="label-verified-solicited"
                id="id-label-verified-solicited"
                name="Label-solicited"
                value="true"
                onChange={this.handleCheckboxChange}
              />
              <label htmlFor="id-label-verified-solicited" className="ml-2">
                Este despejo foi solicitado pela entidade
              </label>
            </div>
            </div>
            
            <div className="row">
            <div className="col-md-6" style={{marginTop: "20px"}}>
           
            <div className="input-box active-grey drop-down-box">
                <label className="input-label" style={{top: "-11px"}}>Auto(s) Origem</label>
                {/* <select className="custome-drop-down" name="DropDownAutoOrigem" id="id-DropDownAutoOrigem" onChange={(e) => DropDownAutoOrigem.handleChange(e)} >
                    <option value="">Selecione...</option>
                </select> */}
                 {estadoQuery == 2 ? 
                 <Select 
                    options={options} 
                    onChange={(e) => DropDownAutoOrigem.handleChange(e)}
                    id="id-DropDownAutoOrigem"
                    defaultValue={options.find(option => option.value == idAutoOrigem)}
                    isDisabled={true}
                  />
                  : window.location.search != "" ? 
                  <Select 
                    options={options} 
                    onChange={(e) => DropDownAutoOrigem.handleChange(e)}
                    id="id-DropDownAutoOrigem"
                    defaultValue={options.find(option => option.value == idAutoOrigem)}
                    isDisabled = {this.state.isCheckboxChecked}
                  />
                  :
                  <Select 
                    options={options} 
                    onChange={(e) => DropDownAutoOrigem.handleChange(e)}
                    id="id-DropDownAutoOrigem"
                    isDisabled = {this.state.isCheckboxChecked}
                  />
            }
                
               
                
            </div>
              {/* <div className="input-box active-grey drop-down-box">
                  <label className="input-label" style={{top: "-11px"}}>Auto(s) Origem</label>
                 
                  <DropDownAutoOrigem field="AutoOrigem"/>  
                  
              </div> */}
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12" style={{marginTop:"20px" }}>
            <span className="deadlineclenderlable EmissaoReceita">Data de Início Despejo</span>
              <div className="input-box active-grey">
                <DatePicker
                    className="form-control deadlineclender input-1 DataInicioDespejo"
                    size="middle"
                    placeholder="Data de Início Despejo"
                    label="Data de Início Despejo"
                    name="DataInicioDespejo"
                    id="DataInicioDespejo"
                />   
              </div>    
              {/* <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                <label style={{ marginBottom : "0"}}>Data de Início Despejo</label>
                <input className="input-1 DataInicioDespejo" name="DataInicioDespejo" id="DataInicioDespejo" type="date"></input>
              </div> */}
            </div> 
            <div className="col-lg-3 col-md-3 col-sm-12" style={{marginTop:"20px" }}>
            <span className="deadlineclenderlable EmissaoReceita">Data de Fim Despejo</span>
              <div className="input-box active-grey">
                <DatePicker
                    className="form-control deadlineclender input-1 DataFimDespejo"
                    size="middle"
                    placeholder="Data de Fim Despejo"
                    label="Data de Fim Despejo"
                    name="DataFimDespejo"
                    id="DataFimDespejo"
                />    
                {/* <label style={{ marginBottom : "0"}}>Data de Fim Despejo</label>
                <input className="input-1 DataFimDespejo" name="DataFimDespejo" id="DataFimDespejo" type="date"></input> */}
              </div>
            </div> 
            
            </div>
            
          </div>
          {!this.state.isCheckboxChecked && (
            <>
            <div className="head position-relative mb-4 ml-3">
              <h2>Detalhes - Engarrafado</h2>
            </div>
            <div className="col-12" id="id-div-fiscalizacao-grid">
              <FiscalizacaoGrid7.ClassGrid7
                date={new Date()}
                parsed={this.state.parsed}
                changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                linkData={this.state.linkData}
                trans_methods={this.state.trans_methods}
                columnList={this.state.columnsGrid} 
                />
            </div>
            
            </>      
          )} 
          {this.state.isCheckboxChecked && (
            <>
            <div className="head position-relative mb-4 ml-3">
              <h2>Detalhes - Engarrafado</h2>
            </div>
            <div className="col-12" id="id-div-fiscalizacao-grid">
              <FiscalizacaoGrid8.ClassGrid8
                date={new Date()}
                parsed={this.state.parsed}
                changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                linkData={this.state.linkData}
                trans_methods={this.state.trans_methods}
                columnList={this.state.columnsGrid} 
                />
            </div>
            
            </>      
          )} 
        </div>      
      )
    }else if(typeAutoValue == "6" || typeAutoValue == "15"){
     
    return(
        <div className="row grid-style-width pl-4">
          {typeAutoValue == "6" && ($("#Motivo_fisc :selected").val() == '36' || $("#Motivo_fisc :selected").val() == '35' || $("#Motivo_fisc :selected").val() == '49') && (
            <div className="col-lg-3 col-md-3 col-sm-12 input-style-float">
              <div className="input-box active-grey">
                <label style={{ marginBottom : "0"}}>Número da Requisição</label>
                <select class='custome-drop-down' name='NrRequisicao' id="NrRequisicao" onChange={this.handleChangeNrRequisicao}>
                    <option value='0'  selected disabled>Selecione...</option>
                </select>
              </div>
            </div>
          )}
          <div className="col-12">
          <div class="form-check form-check-inline pl-4">
            <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckbox1" value="option1" onChange={this.handleChangeAuto17} />
            <label class="form-check-label" for="inlineCheckbox1">Granel</label>
          </div>
          <div class="form-check form-check-inline pl-4">
            <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckbox2" value="option2" onChange={this.handleChangeAuto17} />
            <label class="form-check-label" for="inlineCheckbox2">Engarrafado</label>
          </div>
          <div class="form-check form-check-inline pl-4">
            <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckbox3" value="option3" onChange={this.handleChangeAuto17}/>
            <label class="form-check-label" for="inlineCheckbox3">Viatura</label>
          </div> 
          <div class="form-check form-check-inline pl-4">
            <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckbox4" value="option4" onChange={this.handleChangeAuto17}/>
            <label class="form-check-label" for="inlineCheckbox4">Selos de Garantia</label>
          </div> 
          <div class="form-check form-check-inline pl-4">
            <input class="form-check-input inlineCheckbox"  type="checkbox" id="inlineCheckbox5" value="option5" onChange={this.handleChangeAuto17}/>
            <label class="form-check-label" for="inlineCheckbox5">Rótulos</label>
          </div>
           </div>
          {granelcheck == true ? 
           <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Vasilhas</h2>
                </div>
                  <div className="col-12" id="id-div-fiscalizacao-grid-1">
                  <FiscalizacaoGrid.ClassGrid
                    date={new Date()}
                    parsed={this.state.parsed}
                    changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                    linkData={this.state.linkData}
                    trans_methods={this.state.trans_methods}
                    columnList={this.state.columnsGrid} />
                   
                  </div>
                </div>
          : ""}
        
        {/* <div className="row">
            <div className="col-12">
              <div className="head position-relative mb-3 mt-3">
                  <h2>Ações</h2>
              </div>
            </div>
        </div> */}
        {/* <div className="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault1"/>
            <label class="form-check-label" for="flexCheckDefault1">
            O representante da entidade foi nomeado fiel depositário, intimando-o a não dispôr da(s) remessa(s) sem prévia autorização do IVDP.
            </label>
          </div>
        </div> */}
        {engarrafadocheck == true  && $("#Motivo_fisc :selected").val() == "50" ? 
        <div className="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault2"/>
            <label class="form-check-label" for="flexCheckDefault2">
            Antes de se iniciar esta ação foi entregue em mão ao representante da entidade supra citada, um documento no qual consta o motivo da referida selagem.
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault3"/>
            <label class="form-check-label" for="flexCheckDefault3">
            A selagem não foi efectuada em virtude de o representante da entidade pretender iniciar o despejo de imediato.
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault4"/>
            <label class="form-check-label" for="flexCheckDefault4">
            A selagem não foi efectuada em virtude da entidade afirmar que vai apresentar recurso. Todavia, se em sede de recurso se confirmar o resultado obtido pelos Serviços Técnicos do IVDP e tiver havido comercialização do vinho entre a data da interposição do recurso e a deliberação da Junta Consultiva de Provadores (JCP), a interposição pela entidade de quaisquer outros recursos durante um período mínimo de 1 ano não terá efeitos suspensivos, efectuando-se sempre a selagem dos vinhos.
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault5"/>
            <label class="form-check-label" for="flexCheckDefault5">
            Em virtude de o vinho ter sido reprovado pela JCP, em sede de recurso, a entidade fica desde já notificada a despejar o vinho com a maior brevidade possível, o que deverá ser efetuado sob controlo dos agentes de fiscalização do IVDP.
            </label>
          </div>
        </div> : ""}
           {engarrafadocheck == true ? 
           <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Engarrafado</h2>
                </div>
                  <div className="col-12" id="id-div-fiscalizacao-grid-2">
                  <FiscalizacaoGrid6.ClassGrid6
                    date={new Date()}
                    parsed={this.state.parsed}
                    changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                    linkData={this.state.linkData}
                    trans_methods={this.state.trans_methods}
                    columnList={ColumnsGridAEngarrafado} />
                  </div>
                </div>
          : ""}
           {viaturacheck == true ? 
           <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Viatura</h2>
                </div>
                  <div className="col-12" id="id-div-fiscalizacao-grid-3">
                  <FiscalizacaoGrid3.ClassGrid3
                    date={new Date()}
                    parsed={this.state.parsed}
                    changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                    linkData={this.state.linkData}
                    trans_methods={this.state.trans_methods}
                    columnList={ColumnsGridViatura} />
                  </div>
                </div>
          : ""}
          {selosGarantiacheck == true ? 
           <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Selos de Garantia</h2>
                </div>
                  <div className="col-12" id="id-div-fiscalizacao-grid-4">
                  <FiscalizacaoGrid4.ClassGrid4
                    date={new Date()}
                    parsed={this.state.parsed}
                    changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                    linkData={this.state.linkData}
                    trans_methods={this.state.trans_methods}
                    columnList={ColumnsGridSelosGarantia} />
                  </div>
                </div>
          : ""}
          {rotuloscheck == true ? 
           <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Rótulos</h2>
                </div>
                  <div className="col-12" id="id-div-fiscalizacao-grid-5">
                  <FiscalizacaoGrid5.ClassGrid5
                    date={new Date()}
                    parsed={this.state.parsed}
                    changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                    linkData={this.state.linkData}
                    trans_methods={this.state.trans_methods}
                    columnList={ColumnsGridRotulos} />
                  </div>
                </div>
          : ""}
          </div>
     )  
    }else if(typeAutoValue == "24"){
     
      return(
          <div className="row grid-style-width pl-4">
            <div className="col-12">
              <p>Volume existente verificado por medição através de:</p>
            <div class="form-check form-check-inline pl-4">
              <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckboxVarejo1" value="option5" />
              <label class="form-check-label" for="inlineCheckboxVarejo1">Leitura de escala graduada</label>
            </div>
            <div class="form-check form-check-inline pl-4">
              <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckboxVarejo2" value="option5" />
              <label class="form-check-label" for="inlineCheckboxVarejo2">Cálculo com cubagem do recipiente</label>
            </div>
            <div class="form-check form-check-inline pl-4">
              <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckboxVarejo3" value="option5" />
              <label class="form-check-label" for="inlineCheckboxVarejo3">Estimativa</label>
            </div>
          </div>
             <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Engarrafado</h2>
              </div>
              <div className="col-12">
                <FiscalizacaoGrid9.ClassGrid9
                  date={new Date()}
                  parsed={this.state.parsed}
                  changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                  linkData={this.state.linkData}
                  trans_methods={this.state.trans_methods}
                  columnList={this.state.ColumnsGridEngarrafadoVistoria} />
              </div>
              </div>
             <div className="row grid-style-width pl-4">
                <div className="head position-relative mb-3 mt-3">
                  <h2>Granel</h2>
                  </div>
                    <div className="col-12" >
                    <FiscalizacaoGrid10.ClassGrid10
                      date={new Date()}
                      parsed={this.state.parsed}
                      changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                      linkData={this.state.linkData}
                      trans_methods={this.state.trans_methods}
                      columnList={this.state.ColumnsGridGranelVistoria} />
                    </div>
                  </div>

             <div className="row grid-style-width pl-4">
                <div className="head position-relative mb-3 mt-3">
                  <h2>Selos de Garantia</h2>
                  </div>
                    <div className="col-12">
                    <FiscalizacaoGrid11.ClassGrid11
                      date={new Date()}
                      parsed={this.state.parsed}
                      changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                      linkData={this.state.linkData}
                      trans_methods={this.state.trans_methods}
                      columnList={this.state.ColumnsGridSelosVistoria} />
                    </div>
              </div>
              {/* <div className="row grid-style-width pl-4">
                <div className="head position-relative mb-3 mt-3">
                  <h2>Cápsulas</h2>
                  </div>
                    <div className="col-12">
                    <FiscalizacaoGrid12.ClassGrid12
                      date={new Date()}
                      parsed={this.state.parsed}
                      changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                      linkData={this.state.linkData}
                      trans_methods={this.state.trans_methods}
                      columnList={this.state.ColumnsGridCapsulasVistoria} />
                    </div>
              </div> */}
             <div className="row grid-style-width pl-4">
                <div className="head position-relative mb-3 mt-3">
                  <h2>Vendas</h2>
                  </div>
                    <div className="col-12" >
                    <FiscalizacaoGrid13.ClassGrid13
                      date={new Date()}
                      parsed={this.state.parsed}
                      changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                      linkData={this.state.linkData}
                      trans_methods={this.state.trans_methods}
                      columnList={this.state.ColumnsGridVendasVistoria} />
                    </div>
                  </div>
            </div>
       )  
      }else if(typeAutoValue == "9"){
      return(
        <div className="row grid-style-width pl-4">
          <div className="col-12">
            <div class="form-check form-check-inline pl-4">
              <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckbox6" value="option5" onChange={this.handleChangeAuto17}/>
              <label class="form-check-label" for="inlineCheckbox3">Rótulos</label>
            </div>
            <div class="form-check form-check-inline pl-4">
              <input class="form-check-input inlineCheckbox" type="checkbox" id="inlineCheckbox7" value="option5" onChange={this.handleChangeAuto17}/>
              <label class="form-check-label" for="inlineCheckbox3">Selos</label>
            </div>
          </div>
          {rotulosOutroAutocheck == true ? 
           <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Rótulos</h2>
                </div>
                  <div className="col-12" id="id-div-fiscalizacao-grid-1">
                  <FiscalizacaoGrid.ClassGrid
                    date={new Date()}
                    parsed={this.state.parsed}
                    changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                    linkData={this.state.linkData}
                    trans_methods={this.state.trans_methods}
                    columnList={ColumnsGridRotulosOutroAuto} />
                  </div>
                </div>
          : ""}
          {selosOutroAutocheck == true ? 
           <div className="row grid-style-width pl-4">
              <div className="head position-relative mb-3 mt-3">
                <h2>Selos</h2>
                </div>
                  <div className="col-12" id="id-div-fiscalizacao-grid-4">
                  <FiscalizacaoGrid4.ClassGrid4
                    date={new Date()}
                    parsed={this.state.parsed}
                    changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                    linkData={this.state.linkData}
                    trans_methods={this.state.trans_methods}
                    columnList={ColumnsGridSelosOutroAuto} />
                  </div>
                </div>
          : ""}
        </div>

        // <div>

        //   <div className="head position-relative mb-4">
        //     <h2>Rótulos</h2>
        //   </div>

        //   <div className="col-12" id="id-div-fiscalizacao-grid">
        //     <FiscalizacaoGrid.ClassGrid
        //       date={new Date()}
        //       parsed={this.state.parsed}
        //       changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
        //       linkData={this.state.linkData}
        //       trans_methods={this.state.trans_methods}
        //       columnList={this.state.columnsGrid} />
        //   </div>

        // </div>

      )

    }else if(typeAutoValue == "10"){
      return(

        <div>

          <div className="head position-relative mb-4">
            <h2>Detalhes - Verificação de Selos de Garantia</h2>
          </div>

          <div className="col-12" id="id-div-fiscalizacao-grid">
            <FiscalizacaoGrid.ClassGrid
              date={new Date()}
              parsed={this.state.parsed}
              changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
              linkData={this.state.linkData}
              trans_methods={this.state.trans_methods}
              columnList={this.state.columnsGrid} 
              />
          </div>

        </div>

      )

    }else if(typeAutoValue == "21"){
      return(

        <div>
          <div className="head position-relative mb-4">
                <h2>Auto</h2>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="input-box active-grey">
              <label className="input-label">Auto De</label>
              <input className="input-1 auto_de" name="auto_de" id="auto_de"></input>
            </div>
          </div>

          <div className="col-12">
              <textarea id="id-div-whiteAuto-textarea" className="textareaWhiteAuto" name="textarea_whiteAuto" rows="20"></textarea>
          </div>
        </div>
        

      )

    }else if(typeAutoValue == "22"){
      
      $("#ParecerFiscalizacao").removeClass("d-none")    

      return(

        <div>

            <div>
              <div className="head position-relative mb-4">
                <h2>Agente Económico</h2>
              </div>

              <div className="row mr-0 ml-0">

                <div className="bg-white middle p20">
                  <div className="head position-relative mb-4">
                    <h5>Agente Económico que se Inscreve</h5>
                  </div>

                  <div>
                  <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>NIF</label>
                          <input className="input-1 OrigemDevolucao" name="NIF" id="NIFAE" type="number" maxlength="9" onChange={this.handleChangeNIFAgente}></input>
                      </div>
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Nome/Designação</label>
                          <input className="input-1 OrigemDevolucao" name="NomeDesignacao" id="NomeDesignacaoAE"></input>
                      </div>
                    </div>
                    
                  </div>

                </div>

                <div className="bg-white middle p20">
                  <div className="head position-relative mb-4">
                    <h5>Agente Económico Detentor das Instalações</h5>
                  </div>

                  <div>
                    <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Nome/Designação</label>
                          <input className="input-1 OrigemDevolucao" name="NomeDesignacao" id="NomeDesignacaoAEI"></input>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>NIF</label>
                          <input className="input-1 OrigemDevolucao" name="NIF" id="NIFAEI" type="number" maxlength="9"></input>
                          
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Representante</label>
                          <input className="input-1 OrigemDevolucao" name="Representante" id="Representante" type="text"></input>
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Cargo</label>
                          <input className="input-1 OrigemDevolucao" name="Cargo" id="Cargo" type="text"></input>
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                        <label style={{ marginBottom : "0"}}>Tipo Identificação</label>
                        <select class='custome-drop-down' name='IdentAE' id="IdentAE" >
                            <option value='0'  selected disabled>Selecione...</option>
                            <option value='B.I.'>B.I.</option>
                            <option value='C.C.'>C.C.</option>
                            <option value='Outro'>Outro</option>
                        </select>

                      </div>
                    </div>

                    <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Nº Identificação</label>
                          {/* <input className="input-1 OrigemDevolucao" name="NIdentificacao" id="NrIdentificacao" type="number" maxlength="9"></input> */}
                          <input className="input-1 OrigemDevolucao" name="NIdentificacao" id="NrIdentificacao" type="number"></input>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

            </div>

            <div className="mt-5">
              <div className="head position-relative mb-4">
                <h2>Instalações</h2>
              </div>

              <div className="row mr-0 ml-0">

                <div className="bg-white middle p20">
                  {/* <div className="row" style={{marginLeft: "1px"}}>
                  <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Código IVV</label>
                          <input className="input-1 OrigemDevolucao" name="CodigoIVV" id="CodigoIVVVist" type="number"  onChange={this.handleCheckCodIVV}></input>
                      </div>
                    </div>
                  </div> */}
                  <div>
                    <div className="col-lg-8 col-md-8 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Designação</label>
                          <input className="input-1 OrigemDevolucao" name="Designacao" id="DesignacaoVist" type="text"></input>
                      </div>
                    </div>
                    
                    <div className="pr-3 pl-3 col-lg-2 col-md-2 col-sm-12 input-style-float">
                    
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Código Postal</label>
                          <div className="row d-flex flex-nowrap align-items-center">
                            <input className="input-1 OrigemDevolucao" placeholder="0000" name="CodigoPostal" id="CodPostalVist1" type="number" maxlength="4"></input>
                            <span>-</span>
                            <input className="input-1 OrigemDevolucao"  placeholder="000" name="CodigoPostal" id="CodPostalVist2" type="number" maxlength="3"></input>
                          </div>
                        </div>
                    </div>

                    <div className="pr-0 col-lg-11 col-md-11 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Morada</label>
                          <input className="input-1 OrigemDevolucao" name="Morada" id="MoradaVist" ></input>
                      </div>
                    </div>

                    <div className="pr-0 col-lg-6 col-md-6 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Proprietário</label>
                          <input className="input-1 OrigemDevolucao" name="Proprietario" id="ProprietarioVist" ></input>
                      </div>
                    </div>

                    <div className="col-lg-2 col-md-2 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>NIF</label>
                          <input className="input-1 OrigemDevolucao" name="NIF" id="NifVist" type="number" maxlength="9"></input>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 input-style-float">
                        <div className="input-box active-grey">
                          <label style={{ marginBottom : "0"}}>Atividades</label>
                          <input className="input-1 OrigemDevolucao" name="Atividades" id="AtividadesVist" type="text" ></input>
                      </div>
                    </div>

                    <div className="row" style={{display: "inline-flex" , width:"-webkit-fill-available" , paddingLeft:"15px" , paddingRight: "15px"}}>
                      <LocationFunction 
                        getLocationData={(key, value) => this.getLocationData(key, value)}
                        distrito_id={ this.state.coddis || ''}
                        country_id={  this.state.codcon || ''}
                        fregusia_id={ this.state.codfrg || ''}
                      />
                    </div>

                    <div className="row mt-3 pl-3 pr-3">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="head position-relative mb-0 ml-0">
                          <h5>Tipo Instalação</h5>
                        </div>
                        <div className="row mt-3 bg-white ml-0 p20 align-items-center"> 
                                <div className="mb-0 col-lg-3 col-md-3 col-sm-12 switchFiscais">

                                  <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" name="Vinificacao" id="Vinificacao"/>
                                    <label class="custom-control-label" for="Vinificacao">Vinificação</label>
                                  </div>

                                </div>

                                <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">

                                  <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" name="Armazenamento" id="Armazenamento"/>
                                    <label class="custom-control-label" for="Armazenamento">Armazenamento</label>
                                  </div>

                                </div>

                                <div className="mb-0 col-lg-5 col-md-5 col-sm-12 switchFiscais">

                                  <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" name="ArmProdAcabado" id="ArmProdAcabado"/>
                                    <label class="custom-control-label" for="ArmProdAcabado">Arm. Prod. Acabado</label>
                                  </div>
                                  
                                </div>
                        </div>
                      </div>
                      
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="head position-relative mb-0 ml-0">
                          <h5>Engarrafamento</h5>
                        </div>
                        <div className="mr-0 ml-0 pr-0">

                          <div className="row mt-3 pr-1 pt-3 pl-2 pb-3 bg-white ml-0 align-items-center">

                                <div className="mb-0 pb-1 pt-1 col-lg-4 col-md-4 col-sm-12 switchFiscais">

                                  <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" name="LinhaPropria" id="LinhaPropria"/>
                                    <label class="custom-control-label" for="LinhaPropria">Linha Própria</label>
                                  </div>

                                </div>

                                <div className="mb-0 pb-1 pt-1 col-lg-4 col-md-4 col-sm-12 switchFiscais">

                                  <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" name="LinhaMovel" id="LinhaMovel"/>
                                    <label class="custom-control-label" for="LinhaMovel">Linha Móvel</label>
                                  </div>

                                </div>

                                <div className="mb-0 pb-1 pt-1 col-lg-4 col-md-4 col-sm-12 switchFiscais">

                                  <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" name="PrestacaoServicos" id="PrestacaoServicos"/>
                                    <label class="custom-control-label" for="PrestacaoServicos">Prestação Serviços</label>
                                  </div>

                                </div>

                          </div>

                        </div>
                      </div>  
                    </div>                

                    <div className="row mt-3 pl-3 mr-0 pr-0">
                      <div className="w-100">
                        <div className="head position-relative mb-0 col-12">
                          <h5>Coordenadas</h5>
                        </div>
                        <div className="row mr-0 ml-0 col-12">

                          <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 CoordenadasFiscais col-lg-auto col-md-auto col-sm-12 d-flex">
                            <div className="input-box active-grey">
                            <input className="input-1 OrigemDevolucao" name="Proprietario" id="ProprietarioCoordenadas1" type="number" style={{height: "1px"}}  ></input>
                            </div>
                            
                              <label class="form-check-label">
                                °
                              </label>
                            </div>
                            <div className="mb-0 CoordenadasFiscais col-lg-auto col-md-auto col-sm-12 d-flex">
                            <div className="input-box active-grey">
                            <input className="input-1 OrigemDevolucao" name="Proprietario" id="ProprietarioCoordenadas2" type="number" style={{height: "1px"}} ></input>
                            </div>
                           
                              <label class="form-check-label">
                                '
                              </label>
                            </div>   

                            <div className="mb-0 CoordenadasFiscais col-lg-auto col-md-auto col-sm-12 d-flex">
                            <div className="input-box active-grey">
                            <input className="input-1 OrigemDevolucao" name="Proprietario" id="ProprietarioCoordenadas3" type="number" style={{height: "1px"}} ></input>
                            </div>
                            
                              <label class="form-check-label">
                                ''
                              </label>
                            </div>
                            <div className="mb-0 CoordenadasFiscaisSelect col-lg-auto col-md-auto col-sm-12 p0">
                              
                              <select class='custome-drop-down input-1' name='latNorteSul' id="latNorteSul">
                                <option value='0' selected disabled></option>
                                <option value='N'>N</option>
                                <option value='S'>S</option>
                              </select>

                            </div>
                            <div className="mb-0 CoordenadasFiscais col-lg-auto col-md-auto col-sm-12 d-flex">
                            <div className="input-box active-grey">
                            <input className="input-1 OrigemDevolucao" name="Proprietario" id="ProprietarioCoordenadas4" type="number" style={{height: "1px"}} ></input>
                            </div>
                            
                              <label class="form-check-label">
                              °
                              </label>
                            </div>
                           
                           
                            <div className="mb-0 CoordenadasFiscais col-lg-auto col-md-auto col-sm-12 d-flex">
                            <div className="input-box active-grey">
                            <input className="input-1 OrigemDevolucao" name="Proprietario" id="ProprietarioCoordenadas5" type="number" style={{height: "1px"}}  ></input>
                            </div>
                            
                              <label class="form-check-label">
                                '
                              </label>
                            </div>       

                            <div className="mb-0 CoordenadasFiscais col-lg-auto col-md-auto col-sm-12 d-flex">
                            <div className="input-box active-grey">
                            <input className="input-1 OrigemDevolucao" name="Proprietario" id="ProprietarioCoordenadas6" type="number" style={{height: "1px"}} ></input>
                            </div>
                            
                              <label class="form-check-label">
                                  ''
                              </label>
                            </div>
                            <div className="mb-0 CoordenadasFiscaisSelect col-lg-auto col-md-auto col-sm-12 p0">
                              
                            <select class='custome-drop-down input-1' name='longEsteOeste' id="longEsteOeste" >
                                <option value='0' selected disabled></option>
                                <option value='E'>E</option>
                                <option value='W'>W</option>
                              </select>


                            </div>
                                

                          </div>

                        </div>
                      </div>
                      
                    </div>    
                  </div>

                </div>

              </div>

            </div>

            <div id="id-requisitos-fiscalizacao" className="mt-5">
              <div className="head position-relative mb-4">
                <h2>Requisitos</h2>
              </div>

              <div className="bg-white middle p20">
                  <div className="head position-relative mb-0">
                    <h5>Requisitos Documentais</h5>
                  </div>

                  <div className="row mt-3  bg-white ml-1 p20 align-items-end">            
                        <div className="col-lg-4 col-md-4 col-sm-12">
                          <div className="head position-relative mb-0 col-12">
                            <h5>Possui plantas das instalações ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 text-align-center">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">

                                    <div class="custom-switch">
                                      <input type="radio" class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao} name="PlantasInstalacoes" id="PlantasInstalacoesSim" value="PlantasInstalacoesSim"/>
                                      <label class="custom-control-label" for="PlantasInstalacoesSim" >Sim</label>
                                    </div>

                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">

                                    <div class="custom-switch">
                                      <input type="radio" class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao} name="PlantasInstalacoes" id="PlantasInstalacoesNao" value="PlantasInstalacoesNao"/>
                                      <label class="custom-control-label" for="PlantasInstalacoesNao">Não</label>
                                    </div>
                                    
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao} name="PlantasInstalacoes" id="PlantasInstalacoesNA" value="PlantasInstalacoesNA"/>
                                      <label class="custom-control-label" for="PlantasInstalacoesNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-4 col-sm-12">
                          <div className="head position-relative mb-0 col-12">
                            <h5>Possui doc. comprovativo do licenciamento, ou requerimento ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao} name="PossuiComprovativoLicenciamento" id="PossuiComprovativoLicenciamentoSim" value="PossuiComprovativoLicenciamentoSim"/>
                                      <label class="custom-control-label" for="PossuiComprovativoLicenciamentoSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" class="custom-control-input ChecksVerificacao"  onChange={this.handleChangeCheckboxesAvaliacao} name="PossuiComprovativoLicenciamento" id="PossuiComprovativoLicenciamentoNao" value="PossuiComprovativoLicenciamentoNao"/>
                                      <label class="custom-control-label" for="PossuiComprovativoLicenciamentoNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao} name="PossuiComprovativoLicenciamento" id="PossuiComprovativoLicenciamentoNA" value="PossuiComprovativoLicenciamentoNA"/>
                                      <label class="custom-control-label" for="PossuiComprovativoLicenciamentoNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>
                      </div>                                   
                    
                <div className="head position-relative mb-0 mt-4">
                  <h5>Requisitos Gerais</h5>
                </div>
                <div className="row mt-3  bg-white ml-1 p20 align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div className="head position-relative mb-0 col-12 p0 mt-3">
                            <h5>Elementos da planta das instalações é correspondente à verificada ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 p0">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao"  onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="ElementosPlantaInstalacoesCorrespondenteVerificada" 
                                      id="ElementosPlantaInstalacoesCorrespondenteVerificadaSim"
                                      value="ElementosPlantaInstalacoesCorrespondenteVerificadaSim"/>
                                      <label class="custom-control-label" for="ElementosPlantaInstalacoesCorrespondenteVerificadaSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao"  onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="ElementosPlantaInstalacoesCorrespondenteVerificada" 
                                      id="ElementosPlantaInstalacoesCorrespondenteVerificadaNao"
                                      value="ElementosPlantaInstalacoesCorrespondenteVerificadaNao"/>
                                      <label class="custom-control-label" for="ElementosPlantaInstalacoesCorrespondenteVerificadaNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="ElementosPlantaInstalacoesCorrespondenteVerificada" 
                                      id="ElementosPlantaInstalacoesCorrespondenteVerificadaNA"
                                      value="ElementosPlantaInstalacoesCorrespondenteVerificadaNA"/>
                                      <label class="custom-control-label" for="ElementosPlantaInstalacoesCorrespondenteVerificadaNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div className="head position-relative mb-0 col-12 p0 mt-3">
                            <h5>Recipientes possuem indicação do nº de ordem ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 p0">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao"  onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNOrdem" 
                                      id="RecipientesIndicacaoNOrdemSim"
                                      value="RecipientesIndicacaoNOrdemSim"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoNOrdemSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao"  onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNOrdem" 
                                      id="RecipientesIndicacaoNOrdemNao"
                                      value="RecipientesIndicacaoNOrdemNao"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoNOrdemNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNOrdem" 
                                      id="RecipientesIndicacaoNOrdemNA"
                                      value="RecipientesIndicacaoNOrdemNA"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoNOrdemNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>



                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div className="head position-relative mb-0 col-12 p0 mt-3">
                            <h5>Recipientes possuem indicação da capacidade ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 p0">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoCapacidade" 
                                      id="RecipientesIndicacaoCapacidadeSim"
                                      value="RecipientesIndicacaoCapacidadeSim"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoCapacidadeSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoCapacidade" 
                                      id="RecipientesIndicacaoCapacidadeNao"
                                      value="RecipientesIndicacaoCapacidadeNao"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoCapacidadeNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoCapacidade" 
                                      id="RecipientesIndicacaoCapacidadeNA"
                                      value="RecipientesIndicacaoCapacidadeNA"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoCapacidadeNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>



                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div className="head position-relative mb-0 col-12 p0 mt-3">
                            <h5>Recipientes possuem indicação da natureza do produto ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 p0">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNatureza" 
                                      id="RecipientesIndicacaoNaturezaSim"
                                      value="RecipientesIndicacaoNaturezaSim"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoNaturezaSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNatureza" 
                                      id="RecipientesIndicacaoNaturezaNao"
                                      value="RecipientesIndicacaoNaturezaNao"/>
                                      <label class="custom-control-label" for="RecipientesIndicacaoNaturezaNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNatureza" 
                                      id="RecipientesIndicacaoNaturezaNA"
                                      value="RecipientesIndicacaoNaturezaNA"
                                      />
                                      <label class="custom-control-label" for="RecipientesIndicacaoNaturezaNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>



                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div className="head position-relative mb-0 col-12 p0 mt-3">
                            <h5>Recipientes possuem indicador de nível ou outro meio de controlo da quantidade ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 p0">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNivelControloQuantidade" 
                                      id="RecipientesIndicacaoNivelControloQuantidadeSim"
                                      value="RecipientesIndicacaoNivelControloQuantidadeSim"
                                      />
                                      <label class="custom-control-label" for="RecipientesIndicacaoNivelControloQuantidadeSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNivelControloQuantidade" 
                                      id="RecipientesIndicacaoNivelControloQuantidadeNao"
                                      value="RecipientesIndicacaoNivelControloQuantidadeNao"
                                      />
                                      <label class="custom-control-label" for="RecipientesIndicacaoNivelControloQuantidadeNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="RecipientesIndicacaoNivelControloQuantidade" 
                                      id="RecipientesIndicacaoNivelControloQuantidadeNA"
                                      value="RecipientesIndicacaoNivelControloQuantidadeNA"
                                      />
                                      <label class="custom-control-label" for="RecipientesIndicacaoNivelControloQuantidadeNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>



                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div className="head position-relative mb-0 col-12 p0 mt-3">
                            <h5>O material que entra em contacto com o vinho é inerte ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 p0">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="MaterialContactoInerte" 
                                      id="MaterialContactoInerteSim"
                                      value="MaterialContactoInerteSim"
                                      />
                                      <label class="custom-control-label" for="MaterialContactoInerteSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="MaterialContactoInerte" 
                                      id="MaterialContactoInerteNao"
                                      value="MaterialContactoInerteNao"
                                      />
                                      <label class="custom-control-label" for="MaterialContactoInerteNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="MaterialContactoInerte" 
                                      id="MaterialContactoInerteNA"
                                      value="MaterialContactoInerteNA"
                                      />
                                      <label class="custom-control-label" for="MaterialContactoInerteNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>   



                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <div className="head position-relative mb-0 col-12 p0 mt-3">
                            <h5>As instalações apresentam boas condições de higiene e segurança ?</h5>
                          </div>
                          <div className="row mr-0 ml-0 col-12 p0">

                            <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="InstalacoesBoasCondicoes" 
                                      id="InstalacoesBoasCondicoesSim"
                                      value="InstalacoesBoasCondicoesSim"
                                      />
                                      <label class="custom-control-label" for="InstalacoesBoasCondicoesSim">Sim</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="InstalacoesBoasCondicoes" 
                                      id="InstalacoesBoasCondicoesNao"
                                      value="InstalacoesBoasCondicoesNao"
                                      />
                                      <label class="custom-control-label" for="InstalacoesBoasCondicoesNao">Não</label>
                                    </div>
                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                                    <div class="custom-switch">
                                      <input type="radio" 
                                      class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                      name="InstalacoesBoasCondicoes" 
                                      id="InstalacoesBoasCondicoesNA"
                                      value="InstalacoesBoasCondicoesNA"
                                      />
                                      <label class="custom-control-label" for="InstalacoesBoasCondicoesNA">N/A</label>
                                    </div>
                                  </div>

                            </div>

                          </div>
                        </div>                                                
                </div>





                <div className="head position-relative mb-0 mt-4">
                  <h5>Requisitos Específicos</h5>
                </div>
                <div className="row mt-3  bg-white ml-1 p20 align-items-end">



                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>A iluminação é adequada e tem proteção contra queda de vidros ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="IluminacaoAdequadaProtecaoVidros" 
                                id="IluminacaoAdequadaProtecaoVidrosSim"
                                value="IluminacaoAdequadaProtecaoVidrosSim"
                                />
                                <label class="custom-control-label" for="IluminacaoAdequadaProtecaoVidrosSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="IluminacaoAdequadaProtecaoVidros" 
                                id="IluminacaoAdequadaProtecaoVidrosNao"
                                value="IluminacaoAdequadaProtecaoVidrosNao"
                                />
                                <label class="custom-control-label" for="IluminacaoAdequadaProtecaoVidrosNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="IluminacaoAdequadaProtecaoVidros" 
                                id="IluminacaoAdequadaProtecaoVidrosNA"
                                value="IluminacaoAdequadaProtecaoVidrosNA"
                                />
                                <label class="custom-control-label" for="IluminacaoAdequadaProtecaoVidrosNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>
                        
                        


                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>A água utilizada é adequada para consumo humano ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="AguaAdequadaConsumoHumano" 
                                id="AguaAdequadaConsumoHumanoSim"
                                value="AguaAdequadaConsumoHumanoSim"
                                />
                                <label class="custom-control-label" for="AguaAdequadaConsumoHumanoSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="AguaAdequadaConsumoHumano" 
                                id="AguaAdequadaConsumoHumanoNao"
                                value="AguaAdequadaConsumoHumanoNao"
                                />
                                <label class="custom-control-label" for="AguaAdequadaConsumoHumanoNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="AguaAdequadaConsumoHumano" 
                                id="AguaAdequadaConsumoHumano"
                                value="AguaAdequadaConsumoHumano"
                                />
                                <label class="custom-control-label" for="AguaAdequadaConsumoHumano">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>


                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>Os produtos de limpeza encontram-se armazenados em locais próprios ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProdutosLimpezaLocaisProprios" 
                                id="ProdutosLimpezaLocaisPropriosSim"
                                value="ProdutosLimpezaLocaisPropriosSim"
                                />
                                <label class="custom-control-label" for="ProdutosLimpezaLocaisPropriosSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProdutosLimpezaLocaisProprios" 
                                id="ProdutosLimpezaLocaisPropriosNao"
                                value="ProdutosLimpezaLocaisPropriosNao"
                                />
                                <label class="custom-control-label" for="ProdutosLimpezaLocaisPropriosNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProdutosLimpezaLocaisProprios" 
                                id="ProdutosLimpezaLocaisPropriosNA"
                                value="ProdutosLimpezaLocaisPropriosNA"
                                />
                                <label class="custom-control-label" for="ProdutosLimpezaLocaisPropriosNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>
                        

                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>Os produtos enológicos encontram-se armazenados em locais próprios ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProdutosEnologicosLocaisProprios"
                                id="ProdutosEnologicosLocaisPropriosSim"
                                value="ProdutosEnologicosLocaisPropriosSim"
                                />
                                <label class="custom-control-label" for="ProdutosEnologicosLocaisPropriosSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProdutosEnologicosLocaisProprios" 
                                id="ProdutosEnologicosLocaisPropriosNao"
                                value="ProdutosEnologicosLocaisPropriosNao"
                                />
                                <label class="custom-control-label" for="ProdutosEnologicosLocaisPropriosNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProdutosEnologicosLocaisProprios" 
                                id="ProdutosEnologicosLocaisPropriosNA"
                                value="ProdutosEnologicosLocaisPropriosNA"
                                />
                                <label class="custom-control-label" for="ProdutosEnologicosLocaisPropriosNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>
                  


                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>Existem recipientes para colocação de residuos sólidos devidamente fechados e identificados ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="RecipientesColocacaoResiduosFechadosIdentificados" 
                                id="RecipientesColocacaoResiduosFechadosIdentificadosSim"
                                value="RecipientesColocacaoResiduosFechadosIdentificadosSim"
                                />
                                <label class="custom-control-label" for="RecipientesColocacaoResiduosFechadosIdentificadosSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="RecipientesColocacaoResiduosFechadosIdentificados" 
                                id="RecipientesColocacaoResiduosFechadosIdentificadosNao"
                                value="RecipientesColocacaoResiduosFechadosIdentificadosNao"
                                />
                                <label class="custom-control-label" for="RecipientesColocacaoResiduosFechadosIdentificadosNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="RecipientesColocacaoResiduosFechadosIdentificados" 
                                id="RecipientesColocacaoResiduosFechadosIdentificadosNA"
                                value="RecipientesColocacaoResiduosFechadosIdentificadosNA"
                                />
                                <label class="custom-control-label" for="RecipientesColocacaoResiduosFechadosIdentificadosNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>



                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>O processo produtivo permite rastreabilidade do produto com indicação do nº de lote ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProcessoRastreabilidadeIndicaçãoNLote" 
                                id="ProcessoRastreabilidadeIndicaçãoNLoteSim"
                                value="ProcessoRastreabilidadeIndicaçãoNLoteSim"
                                />
                                <label class="custom-control-label" for="ProcessoRastreabilidadeIndicaçãoNLoteSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProcessoRastreabilidadeIndicaçãoNLote" 
                                id="ProcessoRastreabilidadeIndicaçãoNLoteNao"
                                value="ProcessoRastreabilidadeIndicaçãoNLoteNao"
                                />
                                <label class="custom-control-label" for="ProcessoRastreabilidadeIndicaçãoNLoteNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ProcessoRastreabilidadeIndicaçãoNLote" 
                                id="ProcessoRastreabilidadeIndicaçãoNLoteNA"
                                value="ProcessoRastreabilidadeIndicaçãoNLoteNA"
                                />
                                <label class="custom-control-label" for="ProcessoRastreabilidadeIndicaçãoNLoteNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>




                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>Meios de extinção de incêndios ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="MeiosExtincaoIncendios" 
                                id="MeiosExtincaoIncendiosSim"
                                value="MeiosExtincaoIncendiosSim"
                                />
                                <label class="custom-control-label" for="MeiosExtincaoIncendiosSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="MeiosExtincaoIncendios"
                                id="MeiosExtincaoIncendiosNao"
                                value="MeiosExtincaoIncendiosNao"
                                />
                                <label class="custom-control-label" for="MeiosExtincaoIncendiosNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="MeiosExtincaoIncendios" 
                                id="MeiosExtincaoIncendiosNA"
                                value="MeiosExtincaoIncendiosNA"
                                />
                                <label class="custom-control-label" for="MeiosExtincaoIncendiosNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>



                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>Material de primeiros socorros ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="MeiosPrimeirosSocorros" 
                                id="MeiosPrimeirosSocorrosSim"
                                value="MeiosPrimeirosSocorrosSim"
                                />
                                <label class="custom-control-label" for="MeiosPrimeirosSocorrosSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="MeiosPrimeirosSocorros" 
                                id="MeiosPrimeirosSocorrosNao"
                                value="MeiosPrimeirosSocorrosNao"
                                />
                                <label class="custom-control-label" for="MeiosPrimeirosSocorrosNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="MeiosPrimeirosSocorros" 
                                id="MeiosPrimeirosSocorrosNA"
                                value="MeiosPrimeirosSocorrosNA"
                                />
                                <label class="custom-control-label" for="MeiosPrimeirosSocorrosNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                  </div>



                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <div className="head position-relative mb-0 col-12 p0 mt-3">
                      <h5>Possui ETAR em funcionamento ?</h5>
                    </div>
                    <div className="row mr-0 ml-0 col-12 p0">

                      <div className="bg-white middle w-auto mb-0 pb-0 switch-h-f">

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ETARFuncionamento" 
                                id="ETARFuncionamentoSim"
                                value="ETARFuncionamentoSim"
                                />
                                <label class="custom-control-label" for="ETARFuncionamentoSim">Sim</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ETARFuncionamento" 
                                id="ETARFuncionamentoNao"
                                value="ETARFuncionamentoNao"
                                />
                                <label class="custom-control-label" for="ETARFuncionamentoNao">Não</label>
                              </div>
                            </div>

                            <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais">
                              <div class="custom-switch">
                                <input type="radio" 
                                class="custom-control-input ChecksVerificacao" onChange={this.handleChangeCheckboxesAvaliacao}
                                name="ETARFuncionamento" 
                                id="ETARFuncionamentoNA"
                                value="ETARFuncionamentoNA"
                                />
                                <label class="custom-control-label" for="ETARFuncionamentoNA">N/A</label>
                              </div>
                            </div>

                      </div>

                    </div>
                    
                  </div>
                                            
                </div>
                
            </div>

            <div className="head position-relative mb-4">
                <h2>Dados Técnicos</h2>
              </div>

              <div className="bg-white middle p20">

                <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-12 input-style-float">
                      <div className="input-box active-grey">
                        <label style={{ marginBottom : "0"}}>Área Coberta (m2)</label>
                        <input className="input-1 OrigemDevolucao" name="AreaCoberta" id="AreaCobertaVistoria" type="number" ></input>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 input-style-float">
                      <div className="input-box active-grey">
                        <label style={{ marginBottom : "0"}}>Apoio Técnico - responsável técnico</label>
                        <input className="input-1 OrigemDevolucao" name="ApoioTecnicoResponsavelTecnico" id="ApoioTecnicoVistoria" ></input>
                    </div>
                  </div>

                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais mrg-T-auto mrg-B-auto">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" name="FullTime" id="FullTime"/>
                      <label class="custom-control-label" for="FullTime">FullTime</label>
                    </div>
                  </div>


                </div>

              </div>

          </div>
        </div>
     
      )

    }
    else{

      return(<div>Selecione um Tipo de Auto</div>)

    }
    
  };
    
}

export default FiscalizacaoClassCreateGrid;